import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { memberClinicalCommunicationService } from './member-clinical-Communication.service';

import { ConfigProvider } from '../../shared/services/configprovider';
//import { element } from "protractor";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { SecureStorageService } from '../../secure-storage.service';
import { CupService } from '../../shared/services/cup.service';
import {Modal} from 'bootstrap';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'app-clinical-communications',
    templateUrl: './clinical-communications.component.html',
    styleUrls: ['./clinical-communications.component.scss'],
    providers: [memberClinicalCommunicationService],
    standalone: false
})
export class ClinicalCommunicationsComponent implements OnInit, AfterViewInit {
  memberChangeStatusData: any;
  memberMedicationData: any;
  memberDetailsData: any;
  virtualMemberDetailData: any;
  memberdetailsPdfData: any;
  memberId: any;
  enableClinicSummary: boolean = true;
  inpatientAdmission: boolean;
  enableinpatientAdmission: boolean;
  enablememberstatus: boolean;
  enablememberMedication: boolean;
  inPatientData = [];
  searchInput: any;
  keys: any;
  clinicalSummaryPayload: any;
  memberClinicalData: any;
  memberDetails: any;
  p: number = 1;
  pageSize: number = 1;
  DateFilteredData: any;
  username: any;
  hovering: boolean = false;
  ClinicalSummaryDataResponse: any = {
    PatientClinInfoAip: { AIP: [] },
    PatientClinInfoVisit: { VISIT: [] },
    PatientClinInfoVitals: { VITALS: [] },
  };
  activeEl: any;
  selectedduration: any;
  duration = '30';
  documentsList = [];
  clinicalSummaryParam: void;
  clinicalSummaryresult: any;
  inpatCollapDisplay: boolean = false;
  inpatientClose: boolean = false;
  hoveringRow: any;
  hoveringIpatient: boolean = false;
  hoveringMedication: boolean = false;
  loading: boolean = true;
  clinicalSummaryLoading: boolean = true;
  medicationLoading: boolean = true;
  loadingDashboard: boolean = true;
  inpatientFilterdData: any = [];
  public showMedication: boolean = false;
  public buttonName: any = 'Show';
  encounterDateArray: any = [];
  formattedDate: any = [];
  formattedDateTime: any = [];
  encounterDate: any;
  clinicalEncounterDate: any = [];
  encounterDateForm: UntypedFormGroup;
  checkedList: any = [];
  clinicalSummary: any = [];
  selectedEncounterDateList: any = [];
  notChecked: boolean = true;
  checkboxesLength: boolean = false;
  medicationList: any = [];
  loadingEncounterData: boolean = false;
  pdfDoc: boolean = false;
  medicationRowsData: any = [];
  pdfMedicationData: any = [];
  pdfInpatientData: any = [];
  inpatientRowsData: any = [];
  pdfclinicalSummaryData: any = [];
  clinicalAssesmentRowsData: any = [];
  clinicalVitalsRowsData: any = [];
  counter: number = 0;
  filteredRowsLength: number;
  errorModalFlag: boolean = false;
  unselectFlag: boolean = false;
  assesmentPlanHead: any;
  vitalHead: any;
  public numberOfPages: any;
  admitDischargeHead: any;
  isMobile: boolean = false;
  public viewScreenWidth: any;
  noOfItems: number = 1;
  data = [];
  noDataForVitalPDF: boolean;
  admitDischardeLoading: boolean;
  clinicalActive: boolean;
  admitDischargeActive: boolean;
  medicationChangeActive: boolean;
  clinicalPDFinfo: boolean = false;
  admitDischargePDFinfo: boolean = false;
  medicationChangePDFinfo: boolean = false;
  disableFlag: boolean = false;
  isAdmitDischargeDocAvailable: boolean = false;
  admitDischargeauthId: any;
  admitDischargeauthIdList = [];
  docCode: any;
  docId: any;
  PDFdata = [];
  currentTrIndex:number;
  handleResults(searchObj) {
    this.data = searchObj;
  }

  @ViewChildren('checkboxesPdf') checkboxesPdf: QueryList<ElementRef>;
  @ViewChildren('someVar') myVar;
  @ViewChild('clinicalTableRef') clinicalTableRef: ElementRef;
  medicationHead: string[][];
  reasonForVisit: any;
  locationID: any;

  locationName: any;
  eventID: any;
  eventName: any;
  event: any;
  aips = [];
  vitals = [];
  providerName: any;

  constructor(
    private memberClinicalCommunicationService: memberClinicalCommunicationService,
    private fb: UntypedFormBuilder,
    private cupService: CupService,
    private configProvider: ConfigProvider,
    private secureStorage: SecureStorageService
  ) {
    this.username = this.cupService.getUserNameFromJWT();
    this.getMemberdetails(this.username, this.duration, '');
  }

  selectUnselectAll(event) {
    this.loadingDashboard = true;
    if (event.target.checked == true) {
      this.checkboxesPdf.forEach((element) => {
        element.nativeElement.checked = true;
      });
      this.selectedAllMember('selectAll', event);
    } else {
      event.target.checked == false;
      this.checkboxesPdf.forEach((element) => {
        element.nativeElement.checked = false;
      });
      this.checkedList = [];
      this.pdfMedicationData = [];
      this.pdfInpatientData = [];
      this.pdfclinicalSummaryData = [];
      this.counter = 0;
      this.notChecked = true;
      this.loadingDashboard = false;
    }
  }
  getPDFPrintDataReady(
    medicationData,
    admitDischargeData,
    clinicalSummaryData
  ) {
    const allResponses =
      this.memberClinicalCommunicationService.getPDFPrintData(
        medicationData,
        admitDischargeData,
        clinicalSummaryData,
        this.selectedduration
      );
    if (allResponses && allResponses.length > 0) {
      const memberMedicationData = [];
      const memberadmitDischargeData = [];
      const memberclinicalSummaryData = [];
      this.loadingDashboard = true;
      if (allResponses[0] && allResponses[0][0]) {
        this.loadingDashboard = true;
        allResponses[0][0].subscribe(
          (medicationDataRes) => {
            for (let i = 0; i < medicationDataRes.length; i++) {
              memberMedicationData.push({
                name: allResponses[0][1][i].name,
                id: allResponses[0][1][i].memberId,
                aipResponse: medicationDataRes[i],
                hmoId: allResponses[0][1][i].hmoId,
              });
            }
            memberMedicationData.map((element) => {
              this.memberMedicationWork(
                element.aipResponse,
                element.id,
                'pdfGeneration',
                element.hmoId,
                element.name
              );
            });
            this.loadingDashboard = false;
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        // this.loadingDashboard = false;
      }

      if (allResponses[2] && allResponses[2][0]) {
        this.loadingDashboard = true;
        allResponses[2][0].subscribe(
          (clinicalSummaryDataRes) => {
            for (let i = 0; i < clinicalSummaryDataRes.length; i++) {
              memberclinicalSummaryData.push({
                name: allResponses[2][1][i].name,
                id: allResponses[2][1][i].hmoId,
                aipResponse: clinicalSummaryDataRes[i],
                memberId: allResponses[2][1][i].memberId,
              });
            }
            const apiCalls = [];
            let apiResponse = [];
            memberclinicalSummaryData.map((element) => {
              let clinicalSummaryPayload = {
                startDate: this.onemonth(),
                endDate: this.endDtae(),
                memberId: element.id,
                //memberUId: element.aipResponse,
                memberUId: element.memberId,
              };
              let metaData = {
                name: element.name,
                id: element.id,
                memberId: element.memberId,
              };
              apiCalls.push({
                payload: clinicalSummaryPayload,
                metaData: metaData,
              });
              // this.getMemberClinicalSummary(element.aipResponse['_body'], 'pdfGeneration',
              //   element.memberId, element.id, element.name);
            });

            //console.log("apiCalls-----", apiCalls);
            apiResponse =
              this.memberClinicalCommunicationService.getClinicalAndReason(
                apiCalls
              );
            let clinicalLimit = 0;
            if (
              apiResponse &&
              apiResponse.length > 0 &&
              apiResponse[0] &&
              apiResponse[0].length > 0
            ) {
              clinicalLimit = apiResponse[0][1].length;
              apiResponse[0][0].subscribe(
                (res) => {
                  for (let i = 0; i < apiResponse[0][1].length; i++) {
                    this.getMemberClinicalSummaryWork(
                      res[i + clinicalLimit],
                      res[i],
                      'pdfGeneration',
                      apiResponse[0][1][i].metaData.memberId,
                      apiResponse[0][1][i].metaData.id,
                      apiResponse[0][1][i].metaData.name
                    );
                  }
                  this.loadingDashboard = false;
                },
                (error) => {
                  console.log(error);
                }
              );
            }
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        // this.loadingDashboard = false;
      }
      //admit/discharge
      if (allResponses[1] && allResponses[1][0]) {
        this.loadingDashboard = true;
        allResponses[1][0].subscribe(
          (admitDischargeDataRes) => {
            for (let i = 0; i < admitDischargeDataRes.length; i++) {
              memberadmitDischargeData.push({
                name: allResponses[1][1][i].name,
                id: allResponses[1][1][i].hmoId,
                aipResponse: admitDischargeDataRes[i],
                memberDetails: allResponses[1][1][i].memberDetail,
              });
            }
            memberadmitDischargeData.map((element) => {
              this.inpatientAdmissionWork(
                element.aipResponse,
                element.memberDetails,
                'pdfGeneration',
                element.id,
                element.name
              );
            });
            this.loadingDashboard = false;
          },
          (error) => {
            console.log(error);
            this.loadingDashboard = false;
          }
        );
      } else {
        // this.loadingDashboard = false;
      }
    } else {
      this.loadingDashboard = false;
    }
  }
  selectedAllMember(type, event?) {
    //this.medicationList = [];
    this.loadingDashboard = true;
    $('.innerRows').hide();
    if (event.target.checked) {
      var medicationData = [];
      var admitDischargeData = [];
      var clinicalSummaryData = [];
      this.memberdetailsPdfData.map((element) => {
        this.checkedList.push(element);
        if (element.memberMedicationCount !== 0) {
          let name = element.memberFirstName + element.memberLastName;
          let memberId = element.memberId;
          let hmoId = element.memberHmoID;
          const data = { memberId: memberId, name: name, hmoId: hmoId };
          medicationData.push(data);
        }
        if (element.hospitalCount !== 0) {
          let name = element.memberFirstName + element.memberLastName;
          let hmoId = element.memberHmoID;
          let memberDetail = element;
          const data = {
            memberId: element.memberId,
            memberDetail: memberDetail,
            name: name,
            hmoId: hmoId,
          };
          admitDischargeData.push(data);
        }
        if (element.clinicalFlag !== 0) {
          let name = element.memberFirstName + element.memberLastName;
          let memberId = element.memberId;
          let hmoId = element.memberHmoID;
          const data = { memberId: element.memberId, name: name, hmoId: hmoId };
          clinicalSummaryData.push(data);
        }
      });
      this.notChecked = false;
      this.getPDFPrintDataReady(
        medicationData,
        admitDischargeData,
        clinicalSummaryData
      );
    }
  }
  selectedMember(memberDetails, type, event?) {
    //this.medicationList = [];
    $('.innerRows').hide();
    if (type !== 'selectAll') {
      if (event.target.checked === true) {
        this.notChecked = false;
        if (this.counter < 50) {
          this.counter++;
        } else {
          event.target.checked = false;
          alert('Please select only 5 members.');
        }
      } else if (this.counter > 0) {
        this.counter--;
      }
    }
    if (event.target.checked) {
      this.loadingDashboard = true;
      this.checkedList.push(memberDetails);
      this.notChecked = false;
      if (memberDetails.memberMedicationCount != 0) {
        let memberName =
          memberDetails.memberFirstName + memberDetails.memberLastName;
        this.memberMedication(
          memberDetails.memberId,
          memberDetails.memberHmoID,
          'pdfGeneration',
          memberDetails.memberHmoID,
          memberName
        );
      }

      // Admit Discharge
      if (memberDetails.hospitalCount != 0) {
        let memberName =
          memberDetails.memberFirstName + memberDetails.memberLastName;
        this.inpatientAdmissiondata(
          memberDetails,
          'pdfGeneration',
          memberDetails.memberHmoID,
          memberName
        );
      }

      // clinical summary
      if (memberDetails.clinicalFlag != 0) {
        let memberName =
          memberDetails.memberFirstName + memberDetails.memberLastName;
        this.getPersonIdVal(
          memberDetails.memberId,
          memberDetails.memberHmoID,
          'pdfGeneration',
          memberDetails.memberHmoID,
          memberName
        );
      }
      this.loadingDashboard = false;
    } else if (!event.target.checked) {
      if (this.counter == 0) {
        this.notChecked = true;
      }
      this.checkedList = this.checkedList.filter(
        (x) => x.memberId !== memberDetails.memberId
      );
      if (memberDetails.memberMedicationCount != 0) {
        for (var i = 0; i < this.pdfMedicationData.length; i++) {
          if (this.pdfMedicationData[i].id === memberDetails.memberId) {
            this.pdfMedicationData.splice(i, 1);
          }
        }
      }
      if (memberDetails.hospitalCount != 0) {
        for (var i = 0; i < this.pdfInpatientData.length; i++) {
          if (this.pdfInpatientData[i].id === memberDetails.memberId) {
            this.pdfInpatientData.splice(i, 1);
          }
        }
      }
      //clinical summary
      if (memberDetails.clinicalFlag != 0) {
        for (var i = 0; i < this.pdfclinicalSummaryData.length; i++) {
          if (this.pdfclinicalSummaryData[i].id === memberDetails.memberId) {
            this.pdfclinicalSummaryData.splice(i, 1);
          }
        }
      }
    }
  }
  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }
  errorModal() {
    this.closeModal("errorGeneratePdf");
  }
  clinicalSummaryPDF(memberDetails) {
    let assesmentPlan = [];
    this.encounterDateChange();
    const name =
      memberDetails.memberFirstName.trim() + ' ' + memberDetails.memberLastName;
    this.assesmentPlanHead = [
      ['DETAIL TYPE PRIORITY', 'DETAIL TYPE', 'DESCRIPTION'],
    ];
    this.locationName = this.clinicalEncounterDate[0].locationDetails;
    this.event = this.clinicalEncounterDate[0].eventDetails;
    this.providerName = this.clinicalEncounterDate[0].providerDetails;
    this.clinicalEncounterDate[0].aips.forEach((assement) => {
      let assementTemp;
      if (assement.DetailTypePriority) {
        assesmentPlan = ['DETAIL TYPE PRIORITY', 'DETAIL TYPE', 'DESCRIPTION'];
        assementTemp = [
          assement.DetailTypePriority,
          assement.DetailType,
          assement.Description,
        ];
      } else {
        assesmentPlan = ['Assesment/Plan'];
        this.assesmentPlanHead = [['Assesment/Plan']];
        assementTemp = [
          'No clinical events exist for the selected type, member and date',
        ];
      }

      this.clinicalAssesmentRowsData.push(assementTemp);
    });
    this.clinicalEncounterDate[0].vitals.forEach((csvitals) => {
      let vitalsTemp;
      this.vitalHead = [
        [
          'Time',
          'BP (MM/HG)',
          'Pulse/Min',
          'Resp/Min',
          'Temperature (F)',
          'Height (FT)',
          'Weight (LB)',
          'Weight %',
          'BMI KG/M2',
          'BMI %',
          'BSA M2',
          'O2 Sat%',
          'Pain Score',
        ],
      ];
      var vitalsPlan = [
        'Time',
        'BP (MM/HG)',
        'Pulse/Min',
        'Resp/Min',
        'Temperature (F)',
        'Height (FT)',
        'Weight (LB)',
        'Weight %',
        'BMI KG/M2',
        'BMI %',
        'BSA M2',
        'O2 Sat%',
        'Pain Score',
      ];
      if (
        csvitals !==
        'No clinical events exist for the selected type, member and date'
      ) {
        vitalsTemp = [
          csvitals.Time,
          csvitals.BP,
          csvitals.PulseRate,
          csvitals.Respiration,
          csvitals.TempF,
          csvitals.HeightFt,
          csvitals.WeightLb,
          csvitals.WeightPercent,
          csvitals.BMICalc,
          csvitals.BMIPercent,
          csvitals.BSA,
          csvitals.SPo2,
          csvitals.PainScore,
        ];
      } else {
        this.noDataForVitalPDF = true;
        vitalsTemp = [
          'No clinical events exist for the selected type, member and date',
        ];
        this.vitalHead = [['Vital Details']];
      }
      this.clinicalVitalsRowsData.push(vitalsTemp);
    });

    var doc: any = new jsPDF('l', 'pt');
    doc.setFontSize(15);
    doc.text(
      'Clinical Summary Details for ' +
        this.titleCase(
          memberDetails.memberFirstName.trim() +
            ' ' +
            memberDetails.memberLastName
        ) +
        ' ' +
        '(' +
        memberDetails.memberHmoID +
        '):',
      30,
      60
    );
    doc.setFontSize(12);
    doc.text(
      'Encounter Date: ' +
        this.encounterDate +
        ' (Encounters are listed in Pacific Time)',
      30,
      85
    );
    doc.text('Reason For Visit: ' + this.reasonForVisit, 30, 105);
    doc.text('Provider/Clinician seen : ' + this.providerName, 30, 125);
    doc.text('Location Name : ' + this.locationName, 30, 145);
    doc.text('Event : ' + this.event, 30, 165);
    doc.setFontSize(14);
    autoTable(doc,{
      head: this.assesmentPlanHead,
      body: this.clinicalAssesmentRowsData,
      columnStyles: {
        0: {
          cellWidth: 70,
        },
        1: {
          cellWidth: 100,
        },
        2: {
          cellWidth: 610,
        },
      },
      tableLineColor: [189, 195, 199],
      margin: { left: 30, right: 15 },
      theme: 'grid',
      // showHead:'firstPage',
      headStyles: { fillColor: '#23499E' },
      bodyStyles: { valign: 'top' },
      startY: 190,
    });

    if (doc.lastAutoTable.finalY >= 430) {
      doc.addPage();
      // doc.autoTable.finalY = 10;
    }
    doc.setFontSize(15);
    doc.text(
      'Vitals Details for ' +
        this.titleCase(
          memberDetails.memberFirstName.trim() +
            ' ' +
            memberDetails.memberLastName
        ) +
        ' ' +
        '(' +
        memberDetails.memberHmoID +
        '): ',
      30,
     doc.lastAutoTable.finalY + 45
    );
    doc.setFontSize(12);
    doc.text(
      'Encounter Date: ' +
        this.clinicalEncounterDate[0].EncounterDate +
        ' (Encounters are listed in Pacific Time)',
      30,
      75
    );
    if (this.noDataForVitalPDF) {
      autoTable(doc,{
        head: this.vitalHead,
        body: this.clinicalVitalsRowsData,
        columnStyles: {
          0: {
            cellWidth: 350,
          },
        },
        tableLineColor: [189, 195, 199],
        margin: { left: 30, right: 10 },
        theme: 'grid',
        // showHead:'firstPage',
        headStyles: { fillColor: '#23499E' },
        bodyStyles: { valign: 'top' },
        startY: doc.lastAutoTable.finalY + 85,
      });
    } else {
      autoTable(doc,{
        head: this.vitalHead,
        body: this.clinicalVitalsRowsData,
        columnStyles: {
          0: {
            cellWidth: 60,
          },
          1: {
            cellWidth: 60,
          },
          2: {
            cellWidth: 60,
          },
          3: {
            cellWidth: 60,
          },
          4: {
            cellWidth: 60,
          },
          5: {
            cellWidth: 60,
          },
          6: {
            cellWidth: 60,
          },
          7: {
            cellWidth: 60,
          },
          8: {
            cellWidth: 60,
          },
          9: {
            cellWidth: 60,
          },
          10: {
            cellWidth: 60,
          },
          11: {
            cellWidth: 60,
          },
          12: {
            cellWidth: 60,
          },
        },
        tableLineColor: [189, 195, 199],
        margin: { left: 30, right: 10 },
        theme: 'grid',
        // showHead:'firstPage',
        headStyles: { fillColor: '#23499E' },
        bodyStyles: { valign: 'top' },
        startY: doc.lastAutoTable.finalY + 85,
      });
    }
    this.noDataForVitalPDF = false;
    // ...

    const pageCount = doc.internal.pages.length;
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(10); // optional
      doc.text(
        'Page ' + String(i) + ' of ' + String(pageCount),
        doc.internal.pageSize.width / 2 - 20,
        doc.internal.pageSize.height - 20
      );
      doc.text(
        'Generated: ' + this.todaydate(),
        doc.internal.pageSize.width - 140,
        doc.internal.pageSize.height - 20
      );
    }
    // doc.save('ClinicalCommunicationPDF'+' '+'for'+' '+name +'('+ memberid+')'+'.pdf');
    //  var lastPage = doc.internal.getNumberOfPages();
    //  doc.deletePage(lastPage);
    doc.save(
      'ClinicalSummary_for_' +
        name +
        '_' +
        this.todaydateWithoutSymbols() +
        '.pdf'
    );
    this.clinicalAssesmentRowsData = [];
    this.clinicalVitalsRowsData = [];
    this.medicationChangePDFinfo = false;
    this.admitDischargePDFinfo = false;
    this.clinicalPDFinfo = true;
    this.openModal('pdfInfo');
  }
  medicationChangePDF(memberDetails) {
    var assementTemp;
    const name =
      memberDetails.memberFirstName.trim() + ' ' + memberDetails.memberLastName;
    this.memberMedicationData.forEach((val) => {
      this.medicationHead = [
        [
          'Prescription Start Date',
          'Prescription End Date',
          'Medication Name',
          'Quantity',
          'Number of Refills',
          'Status',
          'Prescriber Name',
          'Notes',
        ],
      ];
      if (val) {
        assementTemp = [
          val.medicationStartDate,
          val.medicationStopDate,
          val.medicationName,
          val.medicationQuantity,
          val.medicationRefills,
          val.status,
          val.prescriberName,
          val.medicationNotes,
        ];
        this.medicationRowsData.push(assementTemp);
      } else {
        assementTemp = [
          'No clinical events exist for the selected type, member and date',
        ];
        this.medicationRowsData.push(assementTemp);
      }
    });
    var doc: any = new jsPDF('l', 'pt');

    autoTable(doc,{
      head: this.medicationHead,
      body: this.medicationRowsData,
      columnStyles: {
        0: {
          cellWidth: 70,
        },
        1: {
          cellWidth: 70,
        },
        2: {
          cellWidth: 100,
        },
        3: {
          cellWidth: 60,
        },
        4: {
          cellWidth: 70,
        },
        5: {
          cellWidth: 90,
        },
        6: {
          cellWidth: 90,
        },
        7: {
          cellWidth: 200,
        },
      },
      margin: { left: 30, right: 20 },
      theme: 'grid',
      //showHead:'firstPage',
      headStyles: { fillColor: '#23499E' },
      //pageBreak: 'always',
      bodyStyles: { valign: 'top' },
      startY: 40,
    });
    const pageCount = doc.getNumberOfPages();
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(16);
      doc.text(
        'Medication Change Details for ' +
          this.titleCase(
            memberDetails.memberFirstName.trim() +
              ' ' +
              memberDetails.memberLastName
          ) +
          ' ' +
          '(' +
          memberDetails.memberHmoID +
          ') within the last ' +
          this.selectedduration +
          ' days',
        30,
        30
      );
      doc.setFontSize(10); // optional
      doc.text(
        'Page ' + String(i) + ' of ' + String(pageCount),
        doc.internal.pageSize.width / 2 - 20,
        doc.internal.pageSize.height - 20
      );
      doc.text(
        'Generated: ' + this.todaydate(),
        doc.internal.pageSize.width - 140,
        doc.internal.pageSize.height - 20
      );
    }
    doc.save(
      'MedicationChange_For_' +
        name +
        '_' +
        this.todaydateWithoutSymbols() +
        '.pdf'
    );
    this.admitDischargePDFinfo = false;
    this.clinicalPDFinfo = false;
    this.medicationChangePDFinfo = true;
    this.openModal('pdfInfo');
    this.medicationRowsData = [];
  }
  async admitDischargePDF(memberDetails) {
    this.loadingDashboard = true;
    let docList = [];
    const name =
      memberDetails.memberFirstName.trim() + ' ' + memberDetails.memberLastName;
    this.inPatientData.forEach((filteredValue, index) => {
      if (filteredValue.docContent) {
        filteredValue.docContent.forEach((element) => {
          this.isAdmitDischargeDocAvailable = true;
          let details = {
            docId: element.docId,
            docCode: element.docCode,
            appId: 'PP',
            AuthID: filteredValue.serviceAuthorization,
          };
          docList.push(details);
        });
      }
      this.admitDischargeauthId = filteredValue.serviceAuthorization;
      let inpatientColumns: any = [];
      if (filteredValue) {
        inpatientColumns = [
          'Service Authorization No',
          'Admit Date',
          'Discharge Date',
          'Admitted Facility',
        ];
        this.admitDischargeHead = [
          [
            'Service Authorization No',
            'Admit Date',
            'Discharge Date',
            'Admitted Facility',
          ],
        ];
        var inpatientTemp = [
          filteredValue.serviceAuthorization,
          filteredValue.memberAdmitDate,
          filteredValue.memberDischargeDate,
          filteredValue.admittedfacility,
        ];
        if (
          filteredValue.inpatientdetailcategory == 'Discharge Diagnosis' ||
          'Discharge Procedure'
        ) {
          inpatientColumns.push('Discharge Diagnosis');
          this.admitDischargeHead = [
            [
              'Service Authorization No',
              'Admit Date',
              'Discharge Date',
              'Admitted Facility',
              'Discharge Diagnosis/Discharge Procedure',
            ],
          ];
          inpatientTemp.push(filteredValue.inpatientdetails);
        }
        if (
          filteredValue.inpatientdetailcategory == 'Discharging Extensivist'
        ) {
          inpatientColumns.push('Discharging Extensivist');
          this.admitDischargeHead = [
            [
              'Service Authorization No',
              'Admit Date',
              'Discharge Date',
              'Admitted Facility',
              'Discharging Extensivist',
            ],
          ];
          inpatientTemp.push(filteredValue.inpatientdetails);
        }
        if (filteredValue.inpatientdetailcategory == 'Admitting Diagnosis ') {
          inpatientColumns.push('Admitting Diagnosis ');
          this.admitDischargeHead = [
            [
              'Service Authorization No',
              'Admit Date',
              'Discharge Date',
              'Admitted Facility',
              'Admitting Diagnosis',
            ],
          ];
          inpatientTemp.push(filteredValue.inpatientdetails);
        }
        if (filteredValue.inpatientdetailcategory == 'Admitting Physician') {
          inpatientColumns.push('Admitting Physician');
          this.admitDischargeHead = [
            [
              'Service Authorization No',
              'Admit Date',
              'Discharge Date',
              'Admitted Facility',
              'Admitting Physician',
            ],
          ];
          inpatientTemp.push(filteredValue.inpatientdetails);
        }

        this.inpatientRowsData.push(inpatientTemp);
      } else {
        inpatientColumns = ['Admit/Discharge'];
        this.admitDischargeHead = [['Admit/Discharge']];
        let val = [
          'No clinical events exist for the selected type, member and date',
        ];
        this.inpatientRowsData.push(val);
      }
    });
    var doc: any = new jsPDF('l', 'pt');

    autoTable(doc,{
      head: this.admitDischargeHead,
      body: this.inpatientRowsData,
      columnStyles: {
        0: {
          cellWidth: 100,
        },
        1: {
          cellWidth: 100,
        },
        2: {
          cellWidth: 100,
        },
        3: {
          cellWidth: 200,
        },
        4: {
          cellWidth: 200,
        },
      },
      margin: { left: 30, right: 20 },
      theme: 'grid',
      //showHead:'firstPage',
      headStyles: { fillColor: '#23499E' },
      bodyStyles: { valign: 'top' },
      startY: 80,
    });
    // ...

    const pageCount = doc.internal.pages.length;
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(16);
      doc.text(
        'Admit/Discharge Details for ' +
          this.titleCase(
            memberDetails.memberFirstName.trim() +
              ' ' +
              memberDetails.memberLastName
          ) +
          ' ' +
          '(' +
          memberDetails.memberHmoID +
          ') within the last ' +
          this.selectedduration +
          ' days',
        30,
        60
      );
      doc.setFontSize(10); // optional
      doc.text(
        'Page ' + String(i) + ' of ' + String(pageCount),
        doc.internal.pageSize.width / 2 - 20,
        doc.internal.pageSize.height - 20
      );
      doc.text(
        'Generated: ' + this.todaydate(),
        doc.internal.pageSize.width - 140,
        doc.internal.pageSize.height - 20
      );
    }
    // doc.lastAutoTablesave(
    //   "AdmitDischargeDetails_For_" +
    //     name +
    //     "_" +
    //     this.todaydateWithoutSymbols() +
    //     ".pdf"
    // );
    // console.log(memberDetails);
    if (this.isAdmitDischargeDocAvailable) {
      let baseUrl = doc.output('datauri');
      var partsOfStr = baseUrl.split(',');

      let pdfDataContents: any;
      if (this.isAdmitDischargeDocAvailable) {
        pdfDataContents = {
          base64: partsOfStr[1],
          admitFlag: 'true',
          docContent: docList,
        };
      }
      this.PDFdata.push(pdfDataContents);

      let response =
        await this.memberClinicalCommunicationService.sendDocumentforSinglePdf(
          this.PDFdata,
          this.admitDischargeauthId
        );
      try {
        if (response) {
          // let blob = new Blob([response.blob()], {type: 'application/pdf'});
          let contentDisposition;
          let contentDispositionData;
          let contentDispositionDisplayName;
          // Array.from(response.headers._headers.entries()).forEach(entry => {
          //   let splitFilename;
          //   if (entry[0] == "content-disposition") {
          //     splitFilename = entry[1];
          //     contentDisposition = splitFilename[0].split(";");
          //     contentDispositionData = contentDisposition[1].split("=");
          //     contentDispositionDisplayName = contentDispositionData[1];
          //     //alert(contentDisposition[1]); this is the dynamic
          //   }
          // }
          // );
          const file = new Blob([response], { type: 'application/pdf' });
          FileSaver.saveAs(
            file,
            'AdmitDischargeDetails_For_' +
              name +
              '_' +
              this.todaydateWithoutSymbols() +
              '.pdf'
          );
          // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //   // for IE
          //   window.navigator.msSaveOrOpenBlob(file, 'adhoc_preview');
          // }
        }
      } catch (ex) {
        console.log(ex);
      }
      this.PDFdata = [];
      this.loadingDashboard = false;
    } else {
      this.loadingDashboard = false;
      doc.save(
        'AdmitDischargeDetails_For_' +
          name +
          '_' +
          this.todaydateWithoutSymbols() +
          '.pdf'
      );
    }
    this.clinicalPDFinfo = false;
    this.medicationChangePDFinfo = false;
    this.admitDischargePDFinfo = true;
    this.openModal('pdfInfo');  
    this.inpatientRowsData = [];
  }
  generatePdfOptions() {
    if (this.counter == 1) {
      this.captureTable('multiple');
    } else {
      event.preventDefault();
      this.openModal('generatePdf');
    }
  }
  public async captureTable(type) {
    this.closeModal('generatePdf');
    if (this.pdfMedicationData.length) {
      let error = this.pdfMedicationData.filter((x) => x.errormsg);
      if (error.length > 0) {
        this.pdfMedicationData = [];
        this.pdfInpatientData = [];
        this.pdfclinicalSummaryData = [];
        this.checkedList = [];
        this.unselectFlag = false;
        this.checkboxesPdf.forEach((element) => {
          element.nativeElement.checked = false;
        });
        this.openModal('errorGeneratePdf');
        return;
      }
    }
    if (this.pdfInpatientData.length) {
      let error = this.pdfInpatientData.filter((x) => x.errormsg);
      if (error.length > 0) {
        this.pdfMedicationData = [];
        this.pdfInpatientData = [];
        this.pdfclinicalSummaryData = [];
        this.checkedList = [];
        this.unselectFlag = false;
        this.checkboxesPdf.forEach((element) => {
          element.nativeElement.checked = false;
        });
        this.openModal('errorGeneratePdf');
        return;
      }
    }
    if (this.pdfclinicalSummaryData.length) {
      let error = this.pdfclinicalSummaryData.filter((x) => x.errormsg);
      if (error.length > 0) {
        this.pdfMedicationData = [];
        this.pdfInpatientData = [];
        this.pdfclinicalSummaryData = [];
        this.checkedList = [];
        this.unselectFlag = false;
        this.checkboxesPdf.forEach((element) => {
          element.nativeElement.checked = false;
        });
        this.openModal('errorGeneratePdf');
        return;
      }
    }
    if (type == 'single') {
      // this.ngProgress.start();
      let name;
      let memberid;
      this.checkedList.forEach(async (member) => {
        name = member.memberFirstName.trim() + ' ' + member.memberLastName;
        memberid = member.memberHmoID;
        var mainHead = [
          [
            'Member ID',
            'Member Name',
            'Date of Birth',
            'Last Event Date',
            'PCP',
            'Clinical Summary',
            'Admit/ Discharge',
            'Medication Change',
          ],
        ];
        var columns = [
          'Member ID',
          'Member Name',
          'Date of Birth',
          'Last Event Date',
          'PCP',
          'Clinical Summary',
          'Admit/ Discharge',
          'Medication Change',
        ];
        var rows = [];
        var temp = [
          member.memberHmoID,
          member.memberFirstName.trim() + ' ' + member.memberLastName,
          member.memberDOB,
          member.mostRecentPatientSeenDate,
          member.pcpName,
          member.clinicalFlag,
          member.hospitalCount,
          member.memberMedicationCount,
        ];
        if (temp[7] > 0) {
          temp[7] = 'Yes';
        } else {
          temp[7] = 'No';
        }
        if (temp[6] > 0) {
          temp[6] = 'Yes';
        } else {
          temp[6] = 'No';
        }
        if (temp[5] > 0) {
          temp[5] = 'Yes';
        } else {
          temp[5] = 'No';
        }
        rows.push(temp);
        var doc: any = new jsPDF('l', 'pt');
        // doc.text(640, 30, 'Generated On: '+this.todaydate());
        doc.text(
          180,
          40,
          'Clinical Communication for ' +
            member.memberFirstName.trim() +
            ' ' +
            member.memberLastName +
            ' within the last ' +
            this.selectedduration +
            ' days'
        );

        autoTable(doc,{
          head: mainHead,
          body: rows,
          columnStyles: {
            0: {
              cellWidth: 80,
            },
            1: {
              cellWidth: 120,
            },
            2: {
              cellWidth: 80,
            },
            3: {
              cellWidth: 100,
            },
            4: {
              cellWidth: 120,
            },
            5: {
              cellWidth: 100,
            },
            6: {
              cellWidth: 100,
            },
            7: {
              cellWidth: 100,
            },
          },
          tableLineColor: [189, 195, 199],
          margin: { left: 30, right: 10 },
          theme: 'grid',
          headStyles: { fillColor: '#23499E' },
          bodyStyles: { valign: 'top' },
          //showHead:'firstPage',
          startY: 60,
          willDrawCell: function (data) {},
        });

        //clinical summary
        let clinicalObj = this.pdfclinicalSummaryData.filter(
          (obj) => obj.id == member.memberId
        );
        clinicalObj.forEach((element, index) => {
          if (element.value) {
            element.value.forEach((val) => {
              var assesmentPlan;
              this.assesmentPlanHead = [
                ['DETAIL TYPE PRIORITY', 'DETAIL TYPE', 'DESCRIPTION'],
              ];
              let encounterId = val.EncounterDate;
              this.reasonForVisit = val.reasonForVisit;
              this.locationName = val.locationName;
              this.event = val.event;
              this.providerName = val.providerName;
              val.aips.forEach((assement) => {
                let assementTemp;
                if (assement.DetailTypePriority) {
                  assesmentPlan = [
                    'DETAIL TYPE PRIORITY',
                    'DETAIL TYPE',
                    'DESCRIPTION',
                  ];
                  assementTemp = [
                    assement.DetailTypePriority,
                    assement.DetailType,
                    assement.Description,
                  ];
                } else {
                  assesmentPlan = ['Assesment/Plan'];
                  this.assesmentPlanHead = [['Assesment/Plan']];
                  assementTemp = [assement.msg];
                }

                this.clinicalAssesmentRowsData.push(assementTemp);
              });
              if (doc.lastAutoTable.finalY >= 300) {
                doc.addPage();
                // doc.lastAutoTable.finalY = 10;
              }
              doc.setFontSize(18);
              doc.text(
                'Clinical Summary: ',
                30,
               doc.lastAutoTable.finalY + 50
              );
              doc.setFontSize(15);
              doc.text(
                'Detail Type Priority - Priority & Detail Type: ',
                30,
               doc.lastAutoTable.finalY + 75
              );
              doc.setFontSize(14);
              doc.text(
                'Encounter Date: ' +
                  encounterId +
                  ' (Encounters are listed in Pacific Time)',
                30,
               doc.lastAutoTable.finalY + 100
              );
              doc.text(
                'Provider/Clinician seen : ' + this.providerName,
                30,
               doc.lastAutoTable.finalY + 125
              );
              doc.text(
                'Reason For Visit : ' + this.reasonForVisit,
                30,
               doc.lastAutoTable.finalY + 150
              );
              doc.text(
                'Location Name : ' + this.locationName,
                30,
               doc.lastAutoTable.finalY + 175
              );
              doc.text(
                'Event : ' + this.event,
                30,
               doc.lastAutoTable.finalY + 200
              );
              autoTable(doc,{
                head: this.assesmentPlanHead,
                body: this.clinicalAssesmentRowsData,
                columnStyles: {
                  0: {
                    cellWidth: 100,
                  },
                  1: {
                    cellWidth: 100,
                  },
                  2: {
                    cellWidth: 600,
                  },
                },
                tableLineColor: [189, 195, 199],
                margin: { left: 30, right: 15 },
                theme: 'grid',
                //showHead:'firstPage',
                headStyles: { fillColor: '#23499E' },
                bodyStyles: { valign: 'top' },
                startY: doc.lastAutoTable.finalY + 225,
              });
              this.clinicalAssesmentRowsData = [];

              val.vitals.forEach((csvitals) => {
                let vitalsTemp;
                this.vitalHead = [
                  [
                    'Time',
                    'BP (MM/HG)',
                    'Pulse/Min',
                    'Resp/Min',
                    'Temperature (F)',
                    'Height (FT)',
                    'Weight (LB)',
                    'Weight %',
                    'BMI KG/M2',
                    'BMI %',
                    'BSA M2',
                    'O2 Sat%',
                    'Pain Score',
                  ],
                ];
                var vitalsPlan = [
                  'Time',
                  'BP (MM/HG)',
                  'Pulse/Min',
                  'Resp/Min',
                  'Temperature (F)',
                  'Height (FT)',
                  'Weight (LB)',
                  'Weight %',
                  'BMI KG/M2',
                  'BMI %',
                  'BSA M2',
                  'O2 Sat%',
                  'Pain Score',
                ];
                if (
                  csvitals.msg !==
                  'No clinical events exist for the selected type, member and date'
                ) {
                  vitalsTemp = [
                    csvitals.Time,
                    csvitals.BP,
                    csvitals.PulseRate,
                    csvitals.Respiration,
                    csvitals.TempF,
                    csvitals.HeightFt,
                    csvitals.WeightLb,
                    csvitals.WeightPercent,
                    csvitals.BMICalc,
                    csvitals.BMIPercent,
                    csvitals.BSA,
                    csvitals.SPo2,
                    csvitals.PainScore,
                  ];
                } else {
                  this.noDataForVitalPDF = true;
                  vitalsTemp = [
                    'No clinical events exist for the selected type, member and date',
                  ];
                  this.vitalHead = [['Vital Details']];
                }

                this.clinicalVitalsRowsData.push(vitalsTemp);
                if (doc.lastAutoTable.finalY >= 430) {
                  doc.addPage();
                  // doc.lastAutoTable.finalY = 10;
                }
                doc.setFontSize(15);
                doc.text(
                  'Vitals Details: ',
                  30,
                 doc.lastAutoTable.finalY + 30
                );
                doc.setFontSize(14);
                doc.text(
                  'Encounter Date : ' +
                    encounterId +
                    ' (Encounters are listed in Pacific Time)',
                  30,
                 doc.lastAutoTable.finalY + 50
                );
                if (this.noDataForVitalPDF) {
                  autoTable(doc,{
                    head: this.vitalHead,
                    body: this.clinicalVitalsRowsData,
                    columnStyles: {
                      0: {
                        cellWidth: 450,
                      },
                    },
                    tableLineColor: [189, 195, 199],
                    margin: { left: 30, right: 10 },
                    theme: 'grid',
                    //showHead:'firstPage',
                    headStyles: { fillColor: '#23499E' },
                    bodyStyles: { valign: 'top' },
                    startY: doc.lastAutoTable.finalY + 60,
                  });
                } else {
                  autoTable(doc,{
                    head: this.vitalHead,
                    body: this.clinicalVitalsRowsData,
                    columnStyles: {
                      0: {
                        cellWidth: 60,
                      },
                      1: {
                        cellWidth: 60,
                      },
                      2: {
                        cellWidth: 60,
                      },
                      3: {
                        cellWidth: 60,
                      },
                      4: {
                        cellWidth: 60,
                      },
                      5: {
                        cellWidth: 60,
                      },
                      6: {
                        cellWidth: 60,
                      },
                      7: {
                        cellWidth: 60,
                      },
                      8: {
                        cellWidth: 60,
                      },
                      9: {
                        cellWidth: 60,
                      },
                      10: {
                        cellWidth: 60,
                      },
                      11: {
                        cellWidth: 60,
                      },
                      12: {
                        cellWidth: 60,
                      },
                    },
                    tableLineColor: [189, 195, 199],
                    margin: { left: 30, right: 10 },
                    theme: 'grid',
                    //showHead:'firstPage',
                    headStyles: { fillColor: '#23499E' },
                    bodyStyles: { valign: 'top' },
                    startY: doc.lastAutoTable.finalY + 60,
                  });
                }
                this.clinicalVitalsRowsData = [];
                this.noDataForVitalPDF = false;
              });
            });
            this.clinicalAssesmentRowsData = [];
            this.clinicalVitalsRowsData = [];
          } else {
            var header = [['Clinical Summary']];

            let val = [element.msg];
            this.clinicalVitalsRowsData.push(val);
            doc.setFontSize(16);
            doc.text(
              'Clinical Summary Details for ' +
                this.titleCase(element.memberName) +
                ' ' +
                element.memberId,
              10,
             doc.lastAutoTable.finalY + 60
            );
            autoTable(doc,{
              head:header,
                body:this.clinicalVitalsRowsData,
              margin: { left: 30, right: 10 },
              bodyStyles: { valign: 'top' },
              startY: doc.lastAutoTable.finalY + 60,
            });
          }
          this.clinicalAssesmentRowsData = [];
          this.clinicalVitalsRowsData = [];
          // this.ngProgress.set(0.3);
        });

        // Medication
        var assementTemp;
        var medicationColumns = [
          'Prescription Start Date',
          'Prescription End Date',
          'Medication Name',
          'Quantity',
          'Number of Refills',
          'Status',
          'Prescriber Name',
          'Notes',
        ];
        let medObj = this.pdfMedicationData.filter(
          (obj) => obj.id == member.memberId
        );
        medObj.forEach((val) => {
          var head = [
            [
              'Prescription Start Date',
              'Prescription End Date',
              'Medication Name',
              'Quantity',
              'Number of Refills',
              'Status',
              'Prescriber Name',
              'Notes',
            ],
          ];
          if (val.value) {
            val.value.forEach((assement) => {
              assementTemp = [
                assement.medicationStartDate,
                assement.medicationStopDate,
                assement.medicationName,
                assement.medicationQuantity,
                assement.medicationRefills,
                assement.status,
                assement.prescriberName,
                assement.medicationNotes,
              ];
              this.medicationRowsData.push(assementTemp);
            });
          } else {
            assementTemp = [val.msg];
            this.medicationRowsData.push(assementTemp);
          }
          if (doc.lastAutoTable.finalY >= 430) {
            doc.addPage();
            // doc.lastAutoTable.finalY = 10;
          }
          doc.setFontSize(16);
          doc.text(
            'Medication Change Details: ',
            30,
           doc.lastAutoTable.finalY + 50
          );
          autoTable(doc,{
            head: head,
            body: this.medicationRowsData,
            columnStyles: {
              0: {
                cellWidth: 70,
              },
              1: {
                cellWidth: 70,
              },
              2: {
                cellWidth: 100,
              },
              3: {
                cellWidth: 60,
              },
              4: {
                cellWidth: 70,
              },
              5: {
                cellWidth: 90,
              },
              6: {
                cellWidth: 90,
              },
              7: {
                cellWidth: 200,
              },
            },
            didParseCell: function (data) {
              var rows = data.table.body;
              if (data.row.index === rows.length - 1) {
                // data.cell.styles.fillColor = [239, 154, 154];
              }
            },
            margin: { left: 30, right: 10 },
            theme: 'grid',
            //showHead:'firstPage',
            headStyles: { fillColor: '#23499E' },
            bodyStyles: { valign: 'top' },
            startY: doc.lastAutoTable.finalY + 70,
          });
          this.medicationRowsData = [];
          // this.ngProgress.set(0.6);
        });

        //InPatient Admit Discharge
        let docList = [];
        let inpatientObj = this.pdfInpatientData.filter(
          (obj) => obj.id == member.memberId
        );

        this.isAdmitDischargeDocAvailable = false;
        inpatientObj.forEach((element, index) => {
          let authIdforMultiPdf = ' ';
          let inpatientColumns: any = [];
          if (element.value) {
            element.value.forEach((filteredValue) => {
              authIdforMultiPdf = filteredValue.serviceAuthorization;
              if (filteredValue.docContent) {
                filteredValue.docContent.forEach((elemen1) => {
                  this.isAdmitDischargeDocAvailable = true;
                  let details = {
                    docId: elemen1.docId,
                    docCode: elemen1.docCode,
                    appId: 'PP',
                    AuthID: filteredValue.serviceAuthorization,
                  };
                  this.admitDischargeauthId =
                    filteredValue.serviceAuthorization;
                  docList.push(details);
                });
              }
              inpatientColumns = [
                'Service Authorization No',
                'Admit Date',
                'Discharge Date',
                'Admitted Facility',
              ];
              this.admitDischargeHead = [
                [
                  'Service Authorization No',
                  'Admit Date',
                  'Discharge Date',
                  'Admitted Facility',
                ],
              ];
              var inpatientTemp = [
                filteredValue.serviceAuthorization,
                filteredValue.memberAdmitDate,
                filteredValue.memberDischargeDate,
                filteredValue.admittedfacility,
              ];
              if (
                filteredValue.inpatientdetailcategory ==
                  'Discharge Diagnosis' ||
                'Discharge Procedure'
              ) {
                inpatientColumns.push('Discharge Diagnosis');
                this.admitDischargeHead = [
                  [
                    'Service Authorization No',
                    'Admit Date',
                    'Discharge Date',
                    'Admitted Facility',
                    'Discharge Diagnosis/Discharge Procedure',
                  ],
                ];
                inpatientTemp.push(filteredValue.inpatientdetails);
              }
              if (
                filteredValue.inpatientdetailcategory ==
                'Discharging Extensivist'
              ) {
                inpatientColumns.push('Discharging Extensivist');
                this.admitDischargeHead = [
                  [
                    'Service Authorization No',
                    'Admit Date',
                    'Discharge Date',
                    'Admitted Facility',
                    'Discharging Extensivist',
                  ],
                ];
                inpatientTemp.push(filteredValue.inpatientdetails);
              }
              if (
                filteredValue.inpatientdetailcategory == 'Admitting Diagnosis '
              ) {
                inpatientColumns.push('Admitting Diagnosis ');
                this.admitDischargeHead = [
                  [
                    'Service Authorization No',
                    'Admit Date',
                    'Discharge Date',
                    'Admitted Facility',
                    'Admitting Diagnosis',
                  ],
                ];
                inpatientTemp.push(filteredValue.inpatientdetails);
              }
              if (
                filteredValue.inpatientdetailcategory == 'Admitting Physician'
              ) {
                inpatientColumns.push('Admitting Physician');
                this.admitDischargeHead = [
                  [
                    'Service Authorization No',
                    'Admit Date',
                    'Discharge Date',
                    'Admitted Facility',
                    'Admitting Physician',
                  ],
                ];
                inpatientTemp.push(filteredValue.inpatientdetails);
              }

              this.inpatientRowsData.push(inpatientTemp);
            });
          } else {
            inpatientColumns = ['Admit/Discharge'];
            this.admitDischargeHead = [['Admit/Discharge']];
            let val = [element.msg];
            this.inpatientRowsData.push(val);
          }
          if (doc.lastAutoTable.finalY >= 430) {
            doc.addPage();
            // doc.lastAutoTable.finalY = 10;
          }
          doc.setFontSize(16);
          doc.text(
            'Admit/Discharge Details: ',
            30,
           doc.lastAutoTable.finalY + 50
          );
          autoTable(doc,{
            head: this.admitDischargeHead,
            body: this.inpatientRowsData,
            columnStyles: {
              0: {
                cellWidth: 100,
              },
              1: {
                cellWidth: 100,
              },
              2: {
                cellWidth: 100,
              },
              3: {
                cellWidth: 200,
              },
              4: {
                cellWidth: 200,
              },
            },
            margin: { left: 30, right: 10 },
            theme: 'grid',
            //showHead:'firstPage',
            headStyles: { fillColor: '#23499E' },
            bodyStyles: { valign: 'top' },
            startY: doc.lastAutoTable.finalY + 70,
          });
          inpatientColumns = [];
          this.inpatientRowsData = [];
        });
        const pageCount = doc.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          doc.setFontSize(10); // optional
          doc.text(
            'Page ' + String(i) + ' of ' + String(pageCount),
            doc.internal.pageSize.width / 2 - 20,
            doc.internal.pageSize.height - 20
          );
          doc.text(
            'Generated: ' + this.todaydate(),
            doc.internal.pageSize.width - 140,
            doc.internal.pageSize.height - 20
          );
        }
        // doc.lastAutoTablesave('ClinicalCommunicationPDF'+' '+'for'+' '+name +'('+ memberid+')'+'.pdf');
        //  var lastPage = doc.internal.getNumberOfPages();
        //  doc.lastAutoTabledeletePage(lastPage);
        /// multiple pdf
        try {
          if (this.isAdmitDischargeDocAvailable) {
            // this.memberClinicalCommunicationService.sendDocumentforPdf()
            let baseUrl = doc.output('datauristring');
            var partsOfStr = baseUrl.split(',');

            let PDFdata2 = [];
            let pdfDataContents: any;
            if (this.isAdmitDischargeDocAvailable) {
              pdfDataContents = {
                base64: partsOfStr[1],
                admitFlag: 'true',
                docContent: docList,
              };
            }
            PDFdata2.push(pdfDataContents);
            try {
              let response =
                await this.memberClinicalCommunicationService.sendDocumentforSinglePdf(
                  PDFdata2,
                  this.admitDischargeauthId
                );

              if (response) {
                let nameforAD =
                  member.memberFirstName.trim() + ' ' + member.memberLastName;
                let memberidforAD = member.memberHmoID;
                // let blob = new Blob([response.blob()], {type: 'application/pdf'});
                let contentDisposition;
                let contentDispositionData;
                let contentDispositionDisplayName;
                // Array.from(response.headers._headers.entries()).forEach(entry => {
                //   let splitFilename;
                //   if (entry[0] == "content-disposition") {
                //     splitFilename = entry[1];
                //     contentDisposition = splitFilename[0].split(";");
                //     contentDispositionData = contentDisposition[1].split("=");
                //     contentDispositionDisplayName = contentDispositionData[1];
                //     //alert(contentDisposition[1]); this is the dynamic
                //   }
                // }
                // );
                const file = new Blob([response], { type: 'application/pdf' });
                FileSaver.saveAs(
                  file,
                  'ClinicalCommunicationPDF' +
                    ' ' +
                    'for' +
                    ' ' +
                    nameforAD +
                    '(' +
                    memberidforAD +
                    ')' +
                    '.pdf'
                );
                // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                //   // for IE
                //   window.navigator.msSaveOrOpenBlob(file, 'adhoc_preview');
                // }
              }
            } catch (ex) {
              console.log(ex);
            }
          } else {
            doc.save(
              'ClinicalCommunicationPDF' +
                ' ' +
                'for' +
                ' ' +
                name +
                '(' +
                memberid +
                ')' +
                '.pdf'
            );
          }
        } catch (ex) {
          console.log(ex);
        }
        // unchecking all the selected checkboxes after the pdf is generated
        this.checkboxesPdf.forEach((element) => {
          element.nativeElement.checked = false;
        });
      });
      this.checkedList = [];

      this.pdfMedicationData = [];
      this.pdfInpatientData = [];
      this.isAdmitDischargeDocAvailable = false;
      this.pdfclinicalSummaryData = [];
      this.counter = 0;
      this.notChecked = true;
      // this.ngProgress.done();
    }

    if (type == 'multiple') {
      // single pdf changes -srabani
      let docList = [];
      this.pdfInpatientData.forEach((element, index) => {
        if (element.value) {
          element.value.forEach((filteredValue) => {
            if (filteredValue.docContent) {
              filteredValue.docContent.forEach((elemen1) => {
                this.isAdmitDischargeDocAvailable = true;
                // let details = {
                //   docId: elemen1.docId,
                //   docCode: elemen1.docCode,
                //   appId: "PP",
                //   AuthID: filteredValue.serviceAuthorization,
                // };
                //docList.push(details);
              });
            }
          });
        }
      });
      if (this.isAdmitDischargeDocAvailable) {
        // this.ngProgress.start();

        var frontdoc: any = new jsPDF('l', 'pt');
        // doc.text(640, 30, 'Date: '+this.todaydate());
        let name;
        let memberid;
        var mainHead = [
          [
            'Member ID',
            'Member Name',
            'Date of Birth',
            'Last Event Date',
            'PCP',
            'Clinical Summary',
            'Admit/ Discharge',
            'Medication Change',
          ],
        ];
        var rows = [];
        this.checkedList.forEach((element) => {
          var temp = [
            element.memberHmoID,
            element.memberFirstName.trim() + ' ' + element.memberLastName,
            element.memberDOB,
            element.mostRecentPatientSeenDate,
            element.pcpName,
            element.clinicalFlag,
            element.hospitalCount,
            element.memberMedicationCount,
          ];
          name = element.memberFirstName.trim() + ' ' + element.memberLastName;
          memberid = element.memberHmoID;

          if (temp[7] > 0) {
            temp[7] = 'Yes';
          } else {
            temp[7] = 'No';
          }
          if (temp[6] > 0) {
            temp[6] = 'Yes';
          } else {
            temp[6] = 'No';
          }
          if (temp[5] > 0) {
            temp[5] = 'Yes';
          } else {
            temp[5] = 'No';
          }
          rows.push(temp);
        });

        frontdoc.setFontSize(16);
        frontdoc.text(
          'Clinical Communication for the last ' +
            this.selectedduration +
            ' days',
          frontdoc.internal.pageSize.width / 3,
          35
        );
        (frontdoc as any).autoTable({
          head: mainHead,
          body: rows,
          columnStyles: {
            0: {
              cellWidth: 80,
            },
            1: {
              cellWidth: 120,
            },
            2: {
              cellWidth: 80,
            },
            3: {
              cellWidth: 100,
            },
            4: {
              cellWidth: 120,
            },
            5: {
              cellWidth: 100,
            },
            6: {
              cellWidth: 100,
            },
            7: {
              cellWidth: 100,
            },
          },
          margin: { left: 30, right: 10 },
          theme: 'grid',
          //showHead:'firstPage',
          headStyles: { fillColor: '#23499E' },
          bodyStyles: { valign: 'top' },
          startY: 60,
          willDrawCell: function (data) {},
        });
        const pageCount = frontdoc.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
          frontdoc.setPage(i);
          frontdoc.setFontSize(10); // set the font size
          frontdoc.text(
            'Page ' + String(i) + ' of ' + String(pageCount),
            frontdoc.internal.pageSize.width / 2 - 20,
            frontdoc.internal.pageSize.height - 20
          );
          frontdoc.text(
            'Generated: ' + this.todaydate(),
            frontdoc.internal.pageSize.width - 140,
            frontdoc.internal.pageSize.height - 20
          );
        }

        let baseUrl = frontdoc.output('datauristring');
        var partsOfStr = baseUrl.split(',');
        let emptydocContent = [];

        let emptydocContents = {
          appId: ' ',
          docId: ' ',
          documentCode: ' ',
          AuthID: ' ',
        };

        emptydocContent.push(emptydocContents);

        let pdfDataContents: any;

        pdfDataContents = {
          base64: partsOfStr[1],
          admitFlag: 'false',
          docContent: emptydocContent,
        };
        this.PDFdata.push(pdfDataContents);
        this.checkedList.forEach(async (member) => {
          let clinicalPresent = false;
          let admitPresent = false;
          let medicationPresent = false;
          name = member.memberFirstName.trim() + ' ' + member.memberLastName;
          memberid = member.memberHmoID;
          var apiDOC: any = new jsPDF('l', 'pt');
          // apiDOC.text(640, 30, 'Generated On: '+this.todaydate());
          let memberName =
            member.memberFirstName.trim() + ' ' + member.memberLastName;
          apiDOC.setFontSize(16);
          apiDOC.text(
            'Clinical Communication for ' +
              this.titleCase(memberName) +
              ' ' +
              '(' +
              member.memberHmoID +
              '): ',
            30,
            20
          );
          //clinical summary
          if (
            this.pdfclinicalSummaryData &&
            this.pdfclinicalSummaryData.length
          ) {
            let clinicalObj = this.pdfclinicalSummaryData.filter(
              (obj) => obj.id == member.memberId
            );
            clinicalObj.map((element, index) => {
              if (element.value) {
                element.value.map((val, index2) => {
                  var assesmentPlan;
                  clinicalPresent = true;
                  this.assesmentPlanHead = [
                    ['DETAIL TYPE PRIORITY', 'DETAIL TYPE', 'DESCRIPTION'],
                  ];
                  let encounterId = val.EncounterDate;
                  this.reasonForVisit = val.reasonForVisit;
                  this.locationName = val.locationName;
                  this.event = val.event;
                  this.providerName = val.providerName;
                  val.aips.forEach((assement) => {
                    let assementTemp;
                    if (assement.DetailTypePriority) {
                      assesmentPlan = [
                        'DETAIL TYPE PRIORITY',
                        'DETAIL TYPE',
                        'DESCRIPTION',
                      ];
                      assementTemp = [
                        assement.DetailTypePriority,
                        assement.DetailType,
                        assement.Description,
                      ];
                    } else {
                      assesmentPlan = ['Assesment/Plan'];
                      this.assesmentPlanHead = [['Assesment/Plan']];
                      assementTemp = [assement.msg];
                    }

                    this.clinicalAssesmentRowsData.push(assementTemp);
                  });
                  let initialYIndex = 0;
                  if (
                    apiDOC.lastAutoTable.finalY >= 300 &&
                    apiDOC.lastAutoTable.finalY
                  ) {
                    apiDOC.addPage();
                    apiDOC.lastAutoTable.finalY = 10;
                    initialYIndex = 10;
                  } else if (
                    !apiDOC.lastAutoTable &&
                    apiDOC.lastAutoTable.finalY >= 300
                  ) {
                    initialYIndex = 10;

                    //apiDOC.addPage();
                  } else if (
                    apiDOC.lastAutoTable.finalY <= 300 &&
                    index2 != 0
                  ) {
                    initialYIndex = apiDOC.lastAutoTable.finalY;
                  } else if (
                    apiDOC.lastAutoTable.finalY <= 300 &&
                    index2 == 0
                  ) {
                    initialYIndex = 10;
                  }

                  apiDOC.setFontSize(18);
                  apiDOC.text('Clinical Summary: ', 30, initialYIndex + 30);
                  apiDOC.setFontSize(15);
                  apiDOC.text(
                    'Detail Type Priority - Priority & Detail Type: ',
                    30,
                    //apiDOC.lastAutoTable.finalY + 75
                    initialYIndex + 75
                  );
                  apiDOC.setFontSize(14);
                  apiDOC.text(
                    'Encounter Date: ' +
                      encounterId +
                      ' (Encounters are listed in Pacific Time)',
                    30,
                    // apiDOC.lastAutoTable.finalY + 100
                    initialYIndex + 100
                  );
                  apiDOC.text(
                    'Provider/Clinician seen : ' + this.providerName,
                    30,
                    //apiDOC.lastAutoTable.finalY + 125
                    initialYIndex + 125
                  );
                  apiDOC.text(
                    'Reason For Visit : ' + this.reasonForVisit,
                    30,
                    //apiDOC.lastAutoTable.finalY + 150
                    initialYIndex + 150
                  );
                  apiDOC.text(
                    'Location Name : ' + this.locationName,
                    30,
                    //apiDOC.lastAutoTable.finalY + 175
                    initialYIndex + 175
                  );
                  apiDOC.text('Event : ' + this.event, 30, initialYIndex + 200);
                 autoTable(apiDOC,{
                    head: this.assesmentPlanHead,
                    body: this.clinicalAssesmentRowsData,
                    columnStyles: {
                      0: {
                        cellWidth: 100,
                      },
                      1: {
                        cellWidth: 100,
                      },
                      2: {
                        cellWidth: 600,
                      },
                    },
                    tableLineColor: [189, 195, 199],
                    margin: { left: 30, right: 15 },
                    theme: 'grid',
                    //showHead:'firstPage',
                    headStyles: { fillColor: '#23499E' },
                    bodyStyles: { valign: 'top' },
                    startY: initialYIndex + 225,
                  });
                  this.clinicalAssesmentRowsData = [];

                  val.vitals.forEach((csvitals) => {
                    let vitalsTemp;
                    this.vitalHead = [
                      [
                        'Time',
                        'BP (MM/HG)',
                        'Pulse/Min',
                        'Resp/Min',
                        'Temperature (F)',
                        'Height (FT)',
                        'Weight (LB)',
                        'Weight %',
                        'BMI KG/M2',
                        'BMI %',
                        'BSA M2',
                        'O2 Sat%',
                        'Pain Score',
                      ],
                    ];
                    var vitalsPlan = [
                      'Time',
                      'BP (MM/HG)',
                      'Pulse/Min',
                      'Resp/Min',
                      'Temperature (F)',
                      'Height (FT)',
                      'Weight (LB)',
                      'Weight %',
                      'BMI KG/M2',
                      'BMI %',
                      'BSA M2',
                      'O2 Sat%',
                      'Pain Score',
                    ];
                    if (
                      csvitals.msg !==
                      'No clinical events exist for the selected type, member and date'
                    ) {
                      vitalsTemp = [
                        csvitals.Time,
                        csvitals.BP,
                        csvitals.PulseRate,
                        csvitals.Respiration,
                        csvitals.TempF,
                        csvitals.HeightFt,
                        csvitals.WeightLb,
                        csvitals.WeightPercent,
                        csvitals.BMICalc,
                        csvitals.BMIPercent,
                        csvitals.BSA,
                        csvitals.SPo2,
                        csvitals.PainScore,
                      ];
                    } else {
                      this.noDataForVitalPDF = true;
                      vitalsTemp = [
                        'No clinical events exist for the selected type, member and date',
                      ];
                      this.vitalHead = [['Vital Details']];
                    }

                    this.clinicalVitalsRowsData.push(vitalsTemp);
                    if (apiDOC.lastAutoTable.finalY >= 430) {
                      apiDOC.addPage();
                      apiDOC.lastAutoTable.finalY = 10;
                    }
                    apiDOC.setFontSize(15);
                    apiDOC.text(
                      'Vitals Details: ',
                      30,
                      apiDOC.lastAutoTable.finalY
                        ? apiDOC.lastAutoTable.finalY + 30
                        : 30
                    );
                    apiDOC.setFontSize(14);
                    apiDOC.text(
                      'Encounter Date : ' +
                        encounterId +
                        ' (Encounters are listed in Pacific Time)',
                      30,
                      apiDOC.lastAutoTable.finalY
                        ? apiDOC.lastAutoTable.finalY + 50
                        : 50
                    );
                    if (this.noDataForVitalPDF) {
                    autoTable(apiDOC,{
                        head: this.vitalHead,
                        body: this.clinicalVitalsRowsData,
                        columnStyles: {
                          0: {
                            cellWidth: 450,
                          },
                        },
                        tableLineColor: [189, 195, 199],
                        margin: { left: 30, right: 10 },
                        theme: 'grid',
                        //showHead:'firstPage',
                        headStyles: { fillColor: '#23499E' },
                        bodyStyles: { valign: 'top' },
                        startY: apiDOC.lastAutoTable.finalY
                          ? apiDOC.lastAutoTable.finalY + 60
                          : 60,
                      });
                    } else {
                      autoTable(apiDOC,{
                        head: this.vitalHead,
                        body: this.clinicalVitalsRowsData,
                        columnStyles: {
                          0: {
                            cellWidth: 60,
                          },
                          1: {
                            cellWidth: 60,
                          },
                          2: {
                            cellWidth: 60,
                          },
                          3: {
                            cellWidth: 60,
                          },
                          4: {
                            cellWidth: 60,
                          },
                          5: {
                            cellWidth: 60,
                          },
                          6: {
                            cellWidth: 60,
                          },
                          7: {
                            cellWidth: 60,
                          },
                          8: {
                            cellWidth: 60,
                          },
                          9: {
                            cellWidth: 60,
                          },
                          10: {
                            cellWidth: 60,
                          },
                          11: {
                            cellWidth: 60,
                          },
                          12: {
                            cellWidth: 60,
                          },
                        },
                        tableLineColor: [189, 195, 199],
                        margin: { left: 30, right: 10 },
                        theme: 'grid',
                        //showHead:'firstPage',
                        headStyles: { fillColor: '#23499E' },
                        bodyStyles: { valign: 'top' },
                        startY: apiDOC.lastAutoTable.finalY
                          ? apiDOC.lastAutoTable.finalY + 60
                          : 60,
                      });
                    }
                    this.clinicalVitalsRowsData = [];
                    this.noDataForVitalPDF = false;
                  });
                });
                this.clinicalAssesmentRowsData = [];
                this.clinicalVitalsRowsData = [];
              } else {
                var header = [['Clinical Summary']];

                let val = [element.msg];
                this.clinicalVitalsRowsData.push(val);
                apiDOC.setFontSize(16);
                apiDOC.text(
                  'Clinical Summary Details for ' +
                    this.titleCase(element.memberName) +
                    ' ' +
                    element.memberId,
                  10,
                  // apiDOC.lastAutoTable.finalY + 60
                  apiDOC.lastAutoTable.finalY
                    ? apiDOC.lastAutoTable.finalY + 60
                    : 60
                );
                autoTable(apiDOC, {
                  head:header,
                  body:this.clinicalVitalsRowsData,
                  margin: { left: 30, right: 10 },
                  bodyStyles: { valign: 'top' },
                  startY: apiDOC.lastAutoTable.finalY
                    ? apiDOC.lastAutoTable.finalY + 60
                    : 60,
                });
              }
              this.clinicalAssesmentRowsData = [];
              this.clinicalVitalsRowsData = [];
              // this.ngProgress.set(0.3);
            });
          }
          // Medication
          var assementTemp;
          var medicationColumns = [
            'Prescription Start Date',
            'Prescription End Date',
            'Medication Name',
            'Quantity',
            'Number of Refills',
            'Status',
            'Prescriber Name',
            'Notes',
          ];
          if (this.pdfMedicationData) {
            let medObj = this.pdfMedicationData.filter(
              (obj) => obj.id == member.memberId
            );
            medObj.forEach((val) => {
              var head = [
                [
                  'Prescription Start Date',
                  'Prescription End Date',
                  'Medication Name',
                  'Quantity',
                  'Number of Refills',
                  'Status',
                  'Prescriber Name',
                  'Notes',
                ],
              ];
              if (val.value) {
                val.value.forEach((assement) => {
                  medicationPresent = true;
                  assementTemp = [
                    assement.medicationStartDate,
                    assement.medicationStopDate,
                    assement.medicationName,
                    assement.medicationQuantity,
                    assement.medicationRefills,
                    assement.status,
                    assement.prescriberName,
                    assement.medicationNotes,
                  ];
                  this.medicationRowsData.push(assementTemp);
                });
              } else {
                assementTemp = [val.msg];
                this.medicationRowsData.push(assementTemp);
              }
              let indexForMedication = 0;
              if (
                apiDOC.lastAutoTable.finalY >= 300 &&
                (clinicalPresent || admitPresent)
              ) {
                apiDOC.addPage();
                indexForMedication = 10;
              } else if (
                apiDOC.lastAutoTable.finalY >= 300 &&
                !clinicalPresent &&
                !admitPresent
              ) {
                indexForMedication = 10;
              } else if (
                apiDOC.lastAutoTable.finalY < 300 &&
                !clinicalPresent &&
                !admitPresent
              ) {
                indexForMedication = 10;
              } else if (
                apiDOC.lastAutoTable.finalY < 300 &&
                (clinicalPresent || admitPresent)
              ) {
                indexForMedication = apiDOC.lastAutoTable.finalY + 10;
              }
              apiDOC.setFontSize(16);
              apiDOC.text(
                'Medication Change Details: ',
                30,
                indexForMedication + 50
              );
              autoTable(apiDOC,{
                head: head,
                body: this.medicationRowsData,
                columnStyles: {
                  0: {
                    cellWidth: 70,
                  },
                  1: {
                    cellWidth: 70,
                  },
                  2: {
                    cellWidth: 100,
                  },
                  3: {
                    cellWidth: 60,
                  },
                  4: {
                    cellWidth: 70,
                  },
                  5: {
                    cellWidth: 90,
                  },
                  6: {
                    cellWidth: 90,
                  },
                  7: {
                    cellWidth: 200,
                  },
                },

                margin: { left: 30, right: 10 },
                theme: 'grid',
                //showHead:'firstPage',
                headStyles: { fillColor: '#23499E' },
                bodyStyles: { valign: 'top' },
                startY: indexForMedication + 70,
              });
              this.medicationRowsData = [];
              // this.ngProgress.set(0.6);
            });
          }
          //InPatient Admit Discharge
          docList = [];
          if (this.pdfInpatientData) {
            let inpatientObj = this.pdfInpatientData.filter(
              (obj) => obj.id == member.memberId
            );
            //this.isAdmitDischargeDocAvailable = false;
            inpatientObj.forEach((element) => {
              admitPresent = true;

              let inpatientColumns: any = [];
              if (element.value) {
                element.value.forEach((filteredValue) => {
                  if (filteredValue.docContent) {
                    // this.isAdmitDischargeDocAvailable = true;
                    //   this.docCode = filteredValue.docContent.docCode;
                    //   this.docId= filteredValue.docContent.docId;
                    //   this.admitDischargeauthId=filteredValue.serviceAuthoriza tion;

                    filteredValue.docContent.forEach((elemen1) => {
                      this.isAdmitDischargeDocAvailable = true;
                      let details = {
                        docId: elemen1.docId,
                        docCode: elemen1.docCode,
                        appId: 'PP',
                        AuthID: filteredValue.serviceAuthorization,
                      };
                      this.admitDischargeauthId =
                        filteredValue.serviceAuthorization;
                      docList.push(details);
                    });
                  }
                  inpatientColumns = [
                    'Service Authorization No',
                    'Admit Date',
                    'Discharge Date',
                    'Admitted Facility',
                  ];
                  this.admitDischargeHead = [
                    [
                      'Service Authorization No',
                      'Admit Date',
                      'Discharge Date',
                      'Admitted Facility',
                    ],
                  ];
                  var inpatientTemp = [
                    filteredValue.serviceAuthorization,
                    filteredValue.memberAdmitDate,
                    filteredValue.memberDischargeDate,
                    filteredValue.admittedfacility,
                  ];
                  if (
                    filteredValue.inpatientdetailcategory ==
                      'Discharge Diagnosis' ||
                    'Discharge Procedure'
                  ) {
                    inpatientColumns.push('Discharge Diagnosis');
                    this.admitDischargeHead = [
                      [
                        'Service Authorization No',
                        'Admit Date',
                        'Discharge Date',
                        'Admitted Facility',
                        'Discharge Diagnosis/Discharge Procedure',
                      ],
                    ];
                    inpatientTemp.push(filteredValue.inpatientdetails);
                  }
                  if (
                    filteredValue.inpatientdetailcategory ==
                    'Discharging Extensivist'
                  ) {
                    inpatientColumns.push('Discharging Extensivist');
                    this.admitDischargeHead = [
                      [
                        'Service Authorization No',
                        'Admit Date',
                        'Discharge Date',
                        'Admitted Facility',
                        'Discharging Extensivist',
                      ],
                    ];
                    inpatientTemp.push(filteredValue.inpatientdetails);
                  }
                  if (
                    filteredValue.inpatientdetailcategory ==
                    'Admitting Diagnosis '
                  ) {
                    inpatientColumns.push('Admitting Diagnosis ');
                    this.admitDischargeHead = [
                      [
                        'Service Authorization No',
                        'Admit Date',
                        'Discharge Date',
                        'Admitted Facility',
                        'Admitting Diagnosis',
                      ],
                    ];
                    inpatientTemp.push(filteredValue.inpatientdetails);
                  }
                  if (
                    filteredValue.inpatientdetailcategory ==
                    'Admitting Physician'
                  ) {
                    inpatientColumns.push('Admitting Physician');
                    this.admitDischargeHead = [
                      [
                        'Service Authorization No',
                        'Admit Date',
                        'Discharge Date',
                        'Admitted Facility',
                        'Admitting Physician',
                      ],
                    ];
                    inpatientTemp.push(filteredValue.inpatientdetails);
                  }

                  this.inpatientRowsData.push(inpatientTemp);
                });
              } else {
                inpatientColumns = ['Admit/Discharge'];
                this.admitDischargeHead = [['Admit/Discharge']];
                let val = [element.msg];
                this.inpatientRowsData.push(val);
              }
              let indexForAdmit = 0;
              if (
                apiDOC.lastAutoTable.finalY >= 300 &&
                (clinicalPresent || medicationPresent)
              ) {
                apiDOC.addPage();
                indexForAdmit = 10;
              } else if (
                apiDOC.lastAutoTable.finalY >= 300 &&
                !clinicalPresent &&
                !medicationPresent
              ) {
                indexForAdmit = 10;
              } else if (
                apiDOC.lastAutoTable.finalY < 300 &&
                !clinicalPresent &&
                !medicationPresent
              ) {
                indexForAdmit = 10;
              } else if (
                apiDOC.lastAutoTable.finalY < 300 &&
                (clinicalPresent || medicationPresent)
              ) {
                indexForAdmit = apiDOC.lastAutoTable.finalY + 10;
              }

              apiDOC.setFontSize(16);
              apiDOC.text('Admit/Discharge Details: ', 30, indexForAdmit + 50);
              autoTable(apiDOC,{
                head: this.admitDischargeHead,
                body: this.inpatientRowsData,
                columnStyles: {
                  0: {
                    cellWidth: 100,
                  },
                  1: {
                    cellWidth: 100,
                  },
                  2: {
                    cellWidth: 100,
                  },
                  3: {
                    cellWidth: 200,
                  },
                  4: {
                    cellWidth: 200,
                  },
                },
                margin: { left: 30, right: 10 },
                theme: 'grid',
                //showHead:'firstPage',
                headStyles: { fillColor: '#23499E' },
                bodyStyles: { valign: 'top' },
                startY: indexForAdmit + 70,
              });
              inpatientColumns = [];
              this.inpatientRowsData = [];
            });
          }
          const pageCount = apiDOC.getNumberOfPages();
          for (var i = 1; i <= pageCount; i++) {
            apiDOC.setPage(i);
            apiDOC.setFontSize(10); // optional
            apiDOC.text(
              'Page ' + String(i) + ' of ' + String(pageCount),
              apiDOC.internal.pageSize.width / 2 - 20,
              apiDOC.internal.pageSize.height - 20
            );
            apiDOC.text(
              'Generated: ' + this.todaydate(),
              apiDOC.internal.pageSize.width - 140,
              apiDOC.internal.pageSize.height - 20
            );
          }
          // apiDOC.lastAutoTablesave('ClinicalCommunicationPDF'+' '+'for'+' '+name +'('+ memberid+')'+'.pdf');
          //  var lastPage = apiDOC.internal.getNumberOfPages();
          //  apiDOC.lastAutoTabledeletePage(lastPage);

          // apiDOC.lastAutoTablesave(
          //   "ClinicalCommunication_for_" +
          //     name +
          //     "_" +
          //     this.todaydateWithoutSymbols() +
          //     ".pdf"
          // );

          let baseUrl = apiDOC.output('datauristring');
          var partsOfStr = baseUrl.split(',');
          let emptydocContent = [];

          let emptydocContents = {
            appId: ' ',
            docId: ' ',
            documentCode: ' ',
            AuthID: ' ',
          };

          emptydocContent.push(emptydocContents);

          let pdfDataContents: any;
          if (this.isAdmitDischargeDocAvailable) {
            pdfDataContents = {
              base64: partsOfStr[1],
              admitFlag: 'true',
              docContent: docList,
            };
          } else {
            pdfDataContents = {
              base64: partsOfStr[1],
              admitFlag: 'false',
              docContent: emptydocContent,
            };
          }
          this.PDFdata.push(pdfDataContents);
          // unchecking all the selected checkboxes after the pdf is generated
          this.checkboxesPdf.forEach((element) => {
            element.nativeElement.checked = false;
          });
        });
        //single pdf
        let singlePdfREsponse =
          await this.memberClinicalCommunicationService.sendDocumentforSinglePdf(
            this.PDFdata,
            this.admitDischargeauthId
          );
        try {
          if (singlePdfREsponse) {
            let contentDisposition;
            let contentDispositionData;
            let contentDispositionDisplayName;

            // let splitFilename;
            // if (singlePdfREsponse.headers.get("content-disposition")) {
            //   splitFilename = singlePdfREsponse.headers.get("content-disposition");
            //   contentDisposition = splitFilename.split(";");
            //   contentDispositionData = contentDisposition[1].split("=");
            //   contentDispositionDisplayName = contentDispositionData[1];
            //   //alert(contentDisposition[1]); this is the dynamic
            // }

            const file = new Blob([singlePdfREsponse], {
              type: 'application/pdf',
            });
            FileSaver.saveAs(
              file,
              'ClinicalCommunication_' + this.todaydateWithoutSymbols() + '.pdf'
            );
            // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            //   // for IE
            //   window.navigator.msSaveOrOpenBlob(file, 'adhoc_preview');
            // }
          }
        } catch (ex) {
          console.log(ex);
        }
        //console.log(this.PDFdata);
        this.checkboxesPdf.forEach((element) => {
          element.nativeElement.checked = false;
        });
        this.checkedList = [];
        this.pdfMedicationData = [];
        this.pdfInpatientData = [];
        this.isAdmitDischargeDocAvailable = false;
        this.pdfclinicalSummaryData = [];
        this.counter = 0;
        this.PDFdata = [];
        this.notChecked = true;
        // this.ngProgress.done();
      } else {
        // this.ngProgress.start();
        var doc: any = new jsPDF('l', 'pt');
        // doc.text(640, 30, 'Date: '+this.todaydate());
        let name;
        let memberid;
        var mainHead = [
          [
            'Member ID',
            'Member Name',
            'Date of Birth',
            'Last Event Date',
            'PCP',
            'Clinical Summary',
            'Admit/ Discharge',
            'Medication Change',
          ],
        ];
        var rows = [];
        this.checkedList.forEach((element) => {
          var temp = [
            element.memberHmoID,
            element.memberFirstName.trim() + ' ' + element.memberLastName,
            element.memberDOB,
            element.mostRecentPatientSeenDate,
            element.pcpName,
            element.clinicalFlag,
            element.hospitalCount,
            element.memberMedicationCount,
          ];
          name = element.memberFirstName.trim() + ' ' + element.memberLastName;
          memberid = element.memberHmoID;

          if (temp[7] > 0) {
            temp[7] = 'Yes';
          } else {
            temp[7] = 'No';
          }
          if (temp[6] > 0) {
            temp[6] = 'Yes';
          } else {
            temp[6] = 'No';
          }
          if (temp[5] > 0) {
            temp[5] = 'Yes';
          } else {
            temp[5] = 'No';
          }
          rows.push(temp);
        });

        doc.setFontSize(10);

        autoTable(doc,{
          head: mainHead,
          body: rows,
          columnStyles: {
            0: {
              cellWidth: 80,
            },
            1: {
              cellWidth: 120,
            },
            2: {
              cellWidth: 80,
            },
            3: {
              cellWidth: 100,
            },
            4: {
              cellWidth: 120,
            },
            5: {
              cellWidth: 100,
            },
            6: {
              cellWidth: 100,
            },
            7: {
              cellWidth: 100,
            },
          },
          margin: { left: 30, right: 10 },
          theme: 'grid',
          //showHead:'firstPage',
          headStyles: { fillColor: '#23499E' },
          bodyStyles: { valign: 'top' },
          startY: 60,
          willDrawCell: function (data) {},
        });

        autoTable(doc,{ pageBreak: 'always' });

        this.checkedList.forEach((member) => {
          //clinical summary
          let memberName =
            member.memberFirstName.trim() + ' ' + member.memberLastName;
          doc.setFontSize(16);
          doc.text(
            'Clinical Communication for ' +
              this.titleCase(memberName) +
              ' ' +
              '(' +
              member.memberHmoID +
              '): ',
            30,
           doc.lastAutoTable.finalY + 25
          );
          let clinicalObj = this.pdfclinicalSummaryData.filter(
            (obj) => obj.id == member.memberId
          );
          clinicalObj.forEach((element, index) => {
            if (element.value) {
              element.value.forEach((val) => {
                var assesmentPlan;
                let encounterId = val.EncounterDate;
                let reasonForVisit = val.reasonForVisit;
                this.locationName = val.locationName;
                this.event = val.event;
                this.providerName = val.providerName;
                val.aips.forEach((assement) => {
                  let assementTemp;
                  if (assement.DetailTypePriority) {
                    assesmentPlan = [
                      'DETAIL TYPE PRIORITY',
                      'DETAIL TYPE',
                      'DESCRIPTION',
                    ];
                    this.assesmentPlanHead = [
                      ['DETAIL TYPE PRIORITY', 'DETAIL TYPE', 'DESCRIPTION'],
                    ];
                    assementTemp = [
                      assement.DetailTypePriority,
                      assement.DetailType,
                      assement.Description,
                    ];
                  } else {
                    assesmentPlan = ['Assesment/Plan'];
                    this.assesmentPlanHead = [['Assesment/Plan']];
                    assementTemp = [assement.msg];
                  }

                  this.clinicalAssesmentRowsData.push(assementTemp);
                });
                if (doc.lastAutoTable.finalY >= 300) {
                  doc.addPage();
                  // doc.lastAutoTable.finalY = 10;
                }
                doc.setFontSize(18);
                //doc.text("Clinical Communication for " + this.titleCase(element.memberName)  + " "+ "(" + element.memberId + ") ",10,doc.lastAutoTable.finalY + 25);
                doc.setFontSize(15);
                doc.text(
                  'Clinical Summary: ',
                  30,
                 doc.lastAutoTable.finalY + 50
                );
                doc.text(
                  'Detail Type Priority - Priority & Detail Type: ',
                  30,
                 doc.lastAutoTable.finalY + 75
                );
                doc.setFontSize(14);
                doc.text(
                  'Encounter Date : ' +
                    encounterId +
                    ' (Encounters are listed in Pacific Time)',
                  30,
                 doc.lastAutoTable.finalY + 100
                );
                doc.text(
                  'Provider/Clinician seen : ' + this.providerName,
                  30,
                 doc.lastAutoTable.finalY + 125
                );
                doc.text(
                  'Reason For Visit : ' + reasonForVisit,
                  30,
                 doc.lastAutoTable.finalY + 150
                );
                doc.text(
                  'Location Name : ' + this.locationName,
                  30,
                 doc.lastAutoTable.finalY + 175
                );
                doc.text(
                  'Event : ' + this.event,
                  30,
                 doc.lastAutoTable.finalY + 200
                );
                autoTable(doc,{
                  head: this.assesmentPlanHead,
                  body: this.clinicalAssesmentRowsData,
                  columnStyles: {
                    0: {
                      cellWidth: 100,
                    },
                    1: {
                      cellWidth: 100,
                    },
                    2: {
                      cellWidth: 600,
                    },
                  },
                  margin: { left: 30, right: 15 },
                  theme: 'grid',
                  //showHead:'firstPage',
                  headStyles: { fillColor: '#23499E' },
                  //pageBreak: 'always',
                  bodyStyles: { valign: 'top' },
                  startY: doc.lastAutoTable.finalY + 225,
                });
                this.clinicalAssesmentRowsData = [];

                val.vitals.forEach((csvitals) => {
                  let vitalsTemp;
                  this.vitalHead = [
                    [
                      'Time',
                      'BP (MM/HG)',
                      'Pulse/Min',
                      'Resp/Min',
                      'Temperature (F)',
                      'Height (FT)',
                      'Weight (LB)',
                      'Weight %',
                      'BMI KG/M2',
                      'BMI %',
                      'BSA M2',
                      'O2 Sat%',
                      'Pain Score',
                    ],
                  ];
                  var vitalsPlan = [
                    'Time',
                    'BP (MM/HG)',
                    'Pulse/Min',
                    'Resp/Min',
                    'Temperature (F)',
                    'Height (FT)',
                    'Weight (LB)',
                    'Weight %',
                    'BMI KG/M2',
                    'BMI %',
                    'BSA M2',
                    'O2 Sat%',
                    'Pain Score',
                  ];
                  if (
                    csvitals.msg !==
                    'No clinical events exist for the selected type, member and date'
                  ) {
                    vitalsTemp = [
                      csvitals.Time,
                      csvitals.BP,
                      csvitals.PulseRate,
                      csvitals.Respiration,
                      csvitals.TempF,
                      csvitals.HeightFt,
                      csvitals.WeightLb,
                      csvitals.WeightPercent,
                      csvitals.BMICalc,
                      csvitals.BMIPercent,
                      csvitals.BSA,
                      csvitals.SPo2,
                      csvitals.PainScore,
                    ];
                  } else {
                    this.noDataForVitalPDF = true;
                    vitalsTemp = [
                      'No clinical events exist for the selected type, member and date',
                    ];
                    this.vitalHead = [['Vital Details']];
                  }
                  if (doc.lastAutoTable.finalY >= 430) {
                    doc.addPage();
                    // doc.lastAutoTable.finalY = 10;
                  }
                  this.clinicalVitalsRowsData.push(vitalsTemp);
                  doc.setFontSize(16);
                  doc.text(
                    'Vitals Details: ',
                    30,
                   doc.lastAutoTable.finalY + 50
                  );
                  doc.setFontSize(14);
                  doc.text(
                    'Encounter Date : ' +
                      encounterId +
                      ' (Encounters are listed in Pacific Time)',
                    30,
                   doc.lastAutoTable.finalY + 70
                  );
                  if (this.noDataForVitalPDF) {
                    autoTable(doc,{
                      head: this.vitalHead,
                      body: this.clinicalVitalsRowsData,
                      columnStyles: {
                        0: {
                          cellWidth: 450,
                        },
                      },
                      margin: { left: 30, right: 10, bottom: 20 },
                      theme: 'grid',
                      //showHead:'firstPage',
                      headStyles: { fillColor: '#23499E' },
                      //pageBreak: 'always',
                      bodyStyles: { valign: 'top' },
                      // addPageContent: memberNameInCamecase,
                      startY: doc.lastAutoTable.finalY + 80,
                    });
                  } else {
                    autoTable(doc,{
                      head: this.vitalHead,
                      body: this.clinicalVitalsRowsData,
                      columnStyles: {
                        0: {
                          cellWidth: 60,
                        },
                        1: {
                          cellWidth: 60,
                        },
                        2: {
                          cellWidth: 60,
                        },
                        3: {
                          cellWidth: 60,
                        },
                        4: {
                          cellWidth: 60,
                        },
                        5: {
                          cellWidth: 60,
                        },
                        6: {
                          cellWidth: 60,
                        },
                        7: {
                          cellWidth: 60,
                        },
                        8: {
                          cellWidth: 60,
                        },
                        9: {
                          cellWidth: 60,
                        },
                        10: {
                          cellWidth: 60,
                        },
                        11: {
                          cellWidth: 60,
                        },
                        12: {
                          cellWidth: 60,
                        },
                      },
                      margin: { left: 30, right: 10, bottom: 20 },
                      theme: 'grid',
                      //showHead:'firstPage',
                      headStyles: { fillColor: '#23499E' },
                      //pageBreak: 'always',
                      bodyStyles: { valign: 'top' },
                      // addPageContent: memberNameInCamecase,
                      startY: doc.lastAutoTable.finalY + 80,
                    });
                  }
                  this.clinicalVitalsRowsData = [];
                  this.noDataForVitalPDF = false;
                });
              });
              this.clinicalAssesmentRowsData = [];
              this.clinicalVitalsRowsData = [];
            } else {
              var header = [['Clinical Summary']];

              let val = [element.msg];
              this.clinicalVitalsRowsData.push(val);
              doc.setFontSize(16);
              doc.text(
                'Clinical Communication for ' +
                  this.titleCase(element.memberName) +
                  ' ' +
                  '(' +
                  member.memberHmoID +
                  ')',
                30,
               doc.lastAutoTable.finalY + 30
              );
              autoTable(doc, {
                head:header,
                body:this.clinicalVitalsRowsData,
                margin: { left: 30, right: 10 },
                bodyStyles: { valign: 'top' },
                startY: doc.lastAutoTable.finalY + 60,
              });
            }

            this.clinicalAssesmentRowsData = [];
            this.clinicalVitalsRowsData = [];
            // this.ngProgress.set(0.3);
          });

          // Medication
          var assementTemp;

          let medObj = this.pdfMedicationData.filter(
            (obj) => obj.id == member.memberId
          );
          medObj.forEach((val) => {
            var head = [
              [
                'Prescription Start Date',
                'Prescription End Date',
                'Medication Name',
                'Quantity',
                'Number of Refills',
                'Status',
                'Prescriber Name',
                'Notes',
              ],
            ];
            if (val.value) {
              val.value.forEach((assement) => {
                assementTemp = [
                  assement.medicationStartDate,
                  assement.medicationStopDate,
                  assement.medicationName,
                  assement.medicationQuantity,
                  assement.medicationRefills,
                  assement.status,
                  assement.prescriberName,
                  assement.medicationNotes,
                ];
                this.medicationRowsData.push(assementTemp);
              });
            } else {
              assementTemp = [val.msg];
              this.medicationRowsData.push(assementTemp);
            }
            if (doc.lastAutoTable.finalY >= 430) {
              doc.addPage();
              // doc.lastAutoTable.finalY = 10;
            }
            doc.setFontSize(16);
            doc.text(
              'Medication Change Details: ',
              30,
             doc.lastAutoTable.finalY + 50
            );
            //doc.text("Medication Change Details: ", 10,doc.lastAutoTable.finalY + 50);
            autoTable(doc,{
              head: head,
              body: this.medicationRowsData,
              columnStyles: {
                0: {
                  cellWidth: 70,
                },
                1: {
                  cellWidth: 70,
                },
                2: {
                  cellWidth: 100,
                },
                3: {
                  cellWidth: 60,
                },
                4: {
                  cellWidth: 70,
                },
                5: {
                  cellWidth: 90,
                },
                6: {
                  cellWidth: 90,
                },
                7: {
                  cellWidth: 200,
                },
              },
              margin: { left: 30, right: 10 },
              theme: 'grid',
              //showHead:'firstPage',
              headStyles: { fillColor: '#23499E' },
              //pageBreak: 'always',
              bodyStyles: { valign: 'top' },
              startY: doc.lastAutoTable.finalY + 70,
            });
            this.medicationRowsData = [];
            // this.ngProgress.set(0.6);
          });

          //InPatient Admit Discharge

          let inpatientObj = this.pdfInpatientData.filter(
            (obj) => obj.id == member.memberId
          );
          inpatientObj.forEach((element, index) => {
            let inpatientColumns: any = [];
            if (element.value) {
              element.value.forEach((filteredValue) => {
                inpatientColumns = [
                  'Service Authorization No',
                  'Admit Date',
                  'Discharge Date',
                  'Admitted Facility',
                ];
                this.admitDischargeHead = [
                  [
                    'Service Authorization No',
                    'Admit Date',
                    'Discharge Date',
                    'Admitted Facility',
                  ],
                ];
                var inpatientTemp = [
                  filteredValue.serviceAuthorization,
                  filteredValue.memberAdmitDate,
                  filteredValue.memberDischargeDate,
                  filteredValue.admittedfacility,
                ];
                if (
                  filteredValue.inpatientdetailcategory ==
                    'Discharge Diagnosis' ||
                  'Discharge Procedure'
                ) {
                  inpatientColumns.push('Discharge Diagnosis');
                  this.admitDischargeHead = [
                    [
                      'Service Authorization No',
                      'Admit Date',
                      'Discharge Date',
                      'Admitted Facility',
                      'Discharge Diagnosis/Discharge Procedure',
                    ],
                  ];
                  inpatientTemp.push(filteredValue.inpatientdetails);
                }
                if (
                  filteredValue.inpatientdetailcategory ==
                  'Discharging Extensivist'
                ) {
                  inpatientColumns.push('Discharging Extensivist');
                  this.admitDischargeHead = [
                    [
                      'Service Authorization No',
                      'Admit Date',
                      'Discharge Date',
                      'Admitted Facility',
                      'Discharging Extensivist',
                    ],
                  ];
                  inpatientTemp.push(filteredValue.inpatientdetails);
                }
                if (
                  filteredValue.inpatientdetailcategory ==
                  'Admitting Diagnosis '
                ) {
                  inpatientColumns.push('Admitting Diagnosis ');
                  this.admitDischargeHead = [
                    [
                      'Service Authorization No',
                      'Admit Date',
                      'Discharge Date',
                      'Admitted Facility',
                      'Admitting Diagnosis ',
                    ],
                  ];
                  inpatientTemp.push(filteredValue.inpatientdetails);
                }
                if (
                  filteredValue.inpatientdetailcategory == 'Admitting Physician'
                ) {
                  inpatientColumns.push('Admitting Physician');
                  this.admitDischargeHead = [
                    [
                      'Service Authorization No',
                      'Admit Date',
                      'Discharge Date',
                      'Admitted Facility',
                      'Admitting Physician',
                    ],
                  ];
                  inpatientTemp.push(filteredValue.inpatientdetails);
                }

                this.inpatientRowsData.push(inpatientTemp);
              });
            } else {
              inpatientColumns = ['Admit/Discharge'];
              this.admitDischargeHead = [['Admit/Discharge']];
              let val = [element.msg];
              this.inpatientRowsData.push(val);
            }
            if (doc.lastAutoTable.finalY >= 430) {
              doc.addPage();
              // doc.lastAutoTable.finalY = 10;
            }
            doc.setFontSize(16);
            doc.text(
              'Admit/Discharge Details: ',
              30,
             doc.lastAutoTable.finalY + 50
            );
            //doc.text("Admit/Discharge Details: ", 10,doc.lastAutoTable.finalY + 30);
            autoTable(doc,{
              head: this.admitDischargeHead,
              body: this.inpatientRowsData,
              columnStyles: {
                0: {
                  cellWidth: 100,
                },
                1: {
                  cellWidth: 100,
                },
                2: {
                  cellWidth: 100,
                },
                3: {
                  cellWidth: 200,
                },
                4: {
                  cellWidth: 200,
                },
              },
              margin: { left: 30, right: 10 },
              theme: 'grid',
              //showHead:'firstPage',
              headStyles: { fillColor: '#23499E' },
              bodyStyles: { valign: 'top' },
              startY: doc.lastAutoTable.finalY + 70,
            });
            inpatientColumns = [];
            this.inpatientRowsData = [];
          });

          autoTable(doc,{ pageBreak: 'always' });
        });
        const pageCount = doc.internal.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
          doc.setFontSize(16);
          doc.text(
            'Clinical Communication for the last ' +
              this.selectedduration +
              ' days',
            doc.internal.pageSize.width / 3,
            35
          );
          doc.setPage(i);
          doc.setFontSize(10); // optional
          doc.text(
            'Page ' + String(i) + ' of ' + String(pageCount),
            doc.internal.pageSize.width / 2 - 20,
            doc.internal.pageSize.height - 20
          );
          doc.text(
            'Generated: ' + this.todaydate(),
            doc.internal.pageSize.width - 140,
            doc.internal.pageSize.height - 20
          );
        }
        // doc.lastAutoTablesave('ClinicalCommunicationPDF'+' '+'for'+' '+name +'('+ memberid+')'+'.pdf');
        doc.deletePage(doc.internal.pages.length);
        doc.save(
          'ClinicalCommunication_' + this.todaydateWithoutSymbols() + '.pdf'
        );
        // unchecking all the selected checkboxes after the pdf is generated

        this.checkboxesPdf.forEach((element) => {
          element.nativeElement.checked = false;
        });
        this.checkedList = [];
        this.pdfMedicationData = [];
        this.pdfInpatientData = [];
        this.pdfclinicalSummaryData = [];
        this.counter = 0;
        this.isAdmitDischargeDocAvailable = false;
        this.notChecked = true;
        // this.ngProgress.done();
      }

      this.unselectFlag = false;
    }
  }

  ngAfterViewChecked() {
    this.viewScreenWidth = this.clinicalTableRef.nativeElement.offsetWidth;
    if (this.viewScreenWidth <= 992) {
      this.noOfItems = 1;
    } else {
      this.noOfItems = 10;
    }
  }

  ngOnInit() {
    this.selectedduration = '30';
    $('a.previous').addClass('disable');
  }
  toggleMoreMedication() {
    this.showMedication = !this.showMedication;
    if (this.showMedication) this.buttonName = 'Less';
    else this.buttonName = 'More';
  }

  ngAfterViewInit() {
    var shown = 48;
    var filterItems = $('.accordion-toggle.rows').length;
    if (filterItems > 49) {
      $('#display').show();
    } else {
      $('#display').hide();
    }
    var items = JSON.parse(
      this.secureStorage.getSecureInfoInSessionStorage('resDataLength')
    );
    if ($('.searchMember').val().length == 0) {
      $('.searchInputViewMore').hide();
      if (filterItems > 49) {
        $('.regularViewMore').show();
      }
    }
    // $("#display").click(function () {
    //   var items = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage("resDataLength"));
    //   if ($(".searchMember").val().length > 0) {
    //     $(".regularViewMore").hide();
    //     $(".searchInputViewMore").show();
    //   } else if ($(".searchMember").val().length == 0) {
    //     $(".searchInputViewMore").hide();
    //     $(".regularViewMore").show();
    //     shown = $("#myTable tr:visible").length + 48;
    //     if (shown < items) {
    //       $("#myTable tr.accordion-toggle:lt(" + shown + ")").show();
    //     } else {
    //       $("#myTable tr.accordion-toggle:lt(" + items + ")").show();
    //       if (shown < items) {
    //         $("#myTable tr.accordion-toggle:lt(" + shown + ")").show();
    //       } else {
    //         $("#display").hide();
    //       }
    //     }
    //   }
    // });
    $('#searchInputDisplay').click(function () {
      $('#myTable tr.accordion-toggle').show();
      $(this).hide();
    });
  }
  clickNext() {
    $(
      'table.pagingTable tr:nth-child(-n+' +
        ($('#hdnActivePage').val() * this.pageSize + this.pageSize) +
        ')'
    ).show();
    $(
      'table.pagingTable tr:nth-child(-n+' +
        $('#hdnActivePage').val() * this.pageSize +
        ')'
    ).hide();
    var currentPage = Number($('#hdnActivePage').val());
    // update activepage
    $('#hdnActivePage').val(Number($('#hdnActivePage').val()) + 1);
    // check if previous page button is necessary (not on first page)
    if ($('#hdnActivePage').val() != '1') {
      $('a.previous').show();
      // $("span").show();
    }
    // check if next page button is necessary (not on last page)
    if ($('#hdnActivePage').val() == this.numberOfPages) {
      $('a.next').hide();
      // $("span").hide();
    }
  }
  clickPrevious() {
    var currentPage = Number($('#hdnActivePage').val());
    $('#hdnActivePage').val(currentPage - 1);
    // first hide all rows
    $('table.pagingTable tr.flexColumn').hide();
    // and only turn on visibility on necessary rows
    $(
      'table.pagingTable tr:nth-child(-n+' +
        $('#hdnActivePage').val() * this.pageSize +
        ')'
    ).show();
    $(
      'table.pagingTable tr:nth-child(-n+' +
        ($('#hdnActivePage').val() * this.pageSize - this.pageSize) +
        ')'
    ).hide();
    // check if previous button is necessary (not on first page)
    if ($('#hdnActivePage').val() == '1') {
      $('a.previous').hide();
      // $("span").hide();
    }
    // check if next button is necessary (not on last page)
    if ($('#hdnActivePage').val() < this.numberOfPages) {
      $('a.next').show();
    }
    if ($('#hdnActivePage').val() == 1) {
      // $("a.previous").hide();
    }
  }

  getMemberdetails(name, datelimit, type?, searchedMember?) {
    this.loadingDashboard = true;
    let temp = [];
    let reg = new RegExp(searchedMember, 'gi');
    this.memberDetailsData = [];
    this.memberdetailsPdfData = [];
    this.virtualMemberDetailData = ['loading...'];
    this.memberClinicalCommunicationService
      .getMemberdata(name, datelimit)
      .subscribe(
        (Response) => {
          let ResponseData: any;
          ResponseData = Response;
          if (ResponseData.length > 0) {
            ResponseData.map((element) => {
              let obj: any = {};
              if (
                element.memberStatusCount != 0 ||
                element.hospitalCount != 0 ||
                element.memberMedicationCount != 0 ||
                element.clinicalSummaryFlag != 0
              ) {
                obj.userName = element.userName;
                obj.memberHmoID = element.memberHmoID;
                obj.memberFirstName = element.memberFirstName;
                obj.memberLastName = element.memberLastName;
                obj.memberDOB = this.convertDateFormat(element.memberDOB);
                obj.pcpName = element.pcpName;
                obj.memberId = element.memberUid;
                obj.hospitalCount = element.hospitalCount;
                obj.memberStatusCount = element.memberStatusCount;
                obj.memberMedicationCount = element.memberMedicationCount;
                obj.memnerUid = element.memnerUid;
                obj.clinicalFlag = element.clinicalSummaryFlag; //this.getClinicalFlagVal(obj.memberId);
                obj.mostRecentPatientSeenDate = this.convertDateFormat(
                  element.mostRecentPatientSeenDate
                );
                this.memberdetailsPdfData.push(obj);
                //  temp.push(obj);
              }
            });
            if (this.memberdetailsPdfData && this.memberdetailsPdfData.length) {
              this.memberdetailsPdfData.map((data) => {
                if (
                  reg.test(data.memberHmoID) ||
                  reg.test(data.memberFirstName + data.memberLastName) ||
                  reg.test(data.pcpName)
                ) {
                  this.memberDetailsData.push(data);
                  if (temp && temp.length <= 49) {
                    temp.push(data);
                  }
                }
              });
              setTimeout(() => {
                if (temp && temp.length) {
                  this.virtualMemberDetailData = temp;
                  this.loadingDashboard = false;
                } else {
                  this.virtualMemberDetailData = [
                    'No records found for the searched criteria',
                  ];
                  this.loadingDashboard = false;
                }
              }, 20);
            }
          } else {
            this.loadingDashboard = false;
            this.memberDetailsData = ['No Data found for the time duration'];
            this.virtualMemberDetailData = [
              'No Data found for the time duration',
            ];
            this.memberdetailsPdfData = ['No Data found for the time duration'];
          }

          this.secureStorage.setSecureInfoInSessionlStorage(
            'resDataLength',
            JSON.stringify(this.memberDetailsData.length)
          );
          if (this.memberDetailsData.length >= 49) {
            $('#display').show();
          } else {
            $('#display').hide();
          }

          this.notChecked = true;
          // this.loading=false;
          // this.memberDetailsData.map(row => {
          //   this.getClinicalFlagVal(row.memberId, (res) => { row.clinicalFlag = res });
          // })
        },
        (err) => {
          this.loadingDashboard = false;
          this.notChecked = true;
          this.memberDetailsData = ['No Data found for the time duration'];
          this.virtualMemberDetailData = [
            'No Data found for the time duration',
          ];
          this.memberdetailsPdfData = ['No Data found for the time duration'];
        }
      );
    // this.memberDetailsData=[];
    if (type !== 'selectAll') {
      this.memberDetailsData = [];
      this.virtualMemberDetailData = [];
    }
  }
  loadmore() {
    this.loadingDashboard = true;
    let tempData = [];
    let startIndex = this.virtualMemberDetailData.length;
    let endIndex = this.virtualMemberDetailData.length + 50;
    if (endIndex < this.memberDetailsData.length) {
      for (let i = startIndex; i < endIndex; i++) {
        tempData.push(this.memberDetailsData[i]);
      }
    } else {
      for (
        let i = this.virtualMemberDetailData.length;
        i < this.memberDetailsData.length;
        i++
      ) {
        tempData.push(this.memberDetailsData[i]);
      }
      $('#display').hide();
    }
    this.virtualMemberDetailData =
      this.virtualMemberDetailData.concat(tempData);

    this.loadingDashboard = false;
  }
  getClinicalFlagVal(id, callback) {
    this.memberClinicalCommunicationService
      .getClinicalFlag(id)
      .subscribe((Response) => {
        let ResponseData: any;
        ResponseData = Response;
        callback(ResponseData);
      });
  }

  memberstatus(id) {
    this.memberClinicalCommunicationService
      .getMemberStatusChanged(id)
      .subscribe(
        (Response) => {
          this.memberChangeStatusData = [];

          let ResponseData: any;
          ResponseData = Response;
          ResponseData.forEach((element) => {
            let obj: any = {};
            obj.effectiveDate = this.convertDateFormat(element.effectiveDate);
            obj.majorStatusChange = element.majorStatusChange;
            obj.memberId = element.memberId;
            this.memberChangeStatusData.push(obj);
          });
        },
        (err) => {
          this.memberChangeStatusData = ['No Data found for the time duration'];
        }
      );
    this.memberChangeStatusData = [];
  }

  memberMedication(
    id,
    hmid,
    type?: string,
    memberId?: string,
    memberName?: string
  ) {
    this.loading = true;
    this.medicationLoading = true;
    this.clinicalActive = false;
    this.admitDischargeActive = false;
    this.medicationChangeActive = true;
    setTimeout(() => {
      this.memberClinicalCommunicationService
        .getmemberMedicationData(id, this.selectedduration, memberId)
        .subscribe(
          (Response) => {
            this.memberMedicationWork(Response, id, type, memberId, memberName);
          },
          (err) => {
            let obj = {
              id: id,
              memberId: memberId,
              memberName: memberName,
              msg: 'No clinical events exist for the selected type, member and date',
              errormsg: 'error',
            };
            this.loading = false;
            this.medicationLoading = false;
            this.memberMedicationData = ['No Data found for the time duration'];
            this.pdfMedicationData.push(obj);
          }
        );
    }, 200);
    this.memberMedicationData = [];
  }
  memberMedicationWork(
    Response,
    id,
    type?: string,
    memberId?: string,
    memberName?: string
  ) {
    this.memberMedicationData = [];
    if (true) {
      let ResponseData: any;
      if (Response.hasOwnProperty('body')) {
        ResponseData = Response['body'];
      } else {
        ResponseData = Response;
      }
      let pdfObj: any = {
        id: id,
        memberId: memberId,
        memberName: memberName,
        value: [],
      };
      ResponseData.forEach((element) => {
        let obj: any = {};
        obj.caremorePractive = element.caremorePractive;
        obj.medicationName = element.medicationName;
        obj.medicationNotes = element.medicationNotes;
        obj.medicationPrescriptionDate = this.convertDateFormat(
          element.medicationPrescriptionDate
        );
        obj.medicationQuantity = element.medicationQuantity;
        obj.medicationStartDate = this.convertDateFormat(
          element.medicationStartDate
        );
        obj.memberId = element.memberId;
        obj.prescriberName = element.prescriberName;
        obj.medicationRefills = element.medicationRefills;
        obj.medicationStopDate = this.convertDateFormat(
          element.medicationStopDate
        );
        obj.status = element.status;
        this.memberMedicationData.push(obj);
        if (type == 'pdfGeneration') {
          pdfObj.value.push(obj);
        }
      });
      if (type == 'pdfGeneration') {
        this.pdfMedicationData.push(pdfObj);
      }
    } else {
      let obj = {
        id: id,
        memberId: memberId,
        memberName: memberName,
        msg: 'No clinical events exist for the selected type, member and date',
        errormsg: 'error',
      };
      this.loading = false;
      this.medicationLoading = false;
      this.memberMedicationData = ['No Data found for the time duration'];
      this.pdfMedicationData.push(obj);
    }
    this.medicationLoading = false;
    this.loading = false;
    $('.table.pagingTable tr').show();
    $('.previous,.next').hide();
    var pageSize = 1;
    $('.hdnActivePage').val(1);
    var numberOfPages = this.memberMedicationData.length / pageSize;
    this.numberOfPages = numberOfPages.toFixed();
    if (numberOfPages > 1) {
      $('.next').show();
    }
  }
  getMemberId(memberId) {
    this.memberId = memberId;
  }
  ClinicalSummary() {}
  inpatientAdmissiondata(
    memberDetails,
    type?: string,
    memberId?: string,
    memberName?: string,
    initiateApiCall: boolean = true
  ) {
    this.inpatCollapDisplay = false;
    this.inpatientClose = false;
    this.loading = true;
    this.admitDischardeLoading = true;
    this.clinicalActive = false;
    this.admitDischargeActive = true;
    this.medicationChangeActive = false;
    setTimeout(() => {
      this.memberClinicalCommunicationService
        .getinPatientData(memberDetails, this.selectedduration)
        .subscribe(
          (Response) => {
            this.inpatientAdmissionWork(
              Response,
              memberDetails,
              type,
              memberId,
              memberName
            );
          },
          (err) => {
            if (type == 'pdfGeneration') {
              let obj = {
                id: memberDetails.memberId,
                memberId: memberId,
                memberName: memberName,
                msg: 'No clinical events exist for the selected type, member and date',
                errormsg: 'error',
              };
              this.pdfInpatientData.push(obj);
            }
            this.loading = false;
            this.admitDischardeLoading = false;
            this.inPatientData = [
              'No clinical events exist for the selected type, member and date',
            ];
          }
        );
    }, 500);
  }
  inpatientAdmissionWork(Response, memberDetails, type, memberId, memberName) {
    let docId, docCode;
    this.inPatientData = [];
    let filterDuplicate = [];
    if (true) {
      let ResponseData: any;
      if (Response.hasOwnProperty('body')) {
        ResponseData = Response['body'];
      } else {
        ResponseData = Response;
      }
      let pdfObj: any = {
        id: memberDetails.memberId,
        memberId: memberId,
        memberName: memberName,
        value: [],
      };
      let obj: any = {};
      let duplicate = [];
      let serviceAuthorizationList = [];
      let inpatientDate;
      ResponseData.forEach(async (element, index) => {
        let obj: any = {};
        if (
          element.inpatientdetails != '' &&
          element.inpatientdetails != "Provider Can't Find"
        ) {
          obj.admittedfacility = element.admittedfacility;
          obj.inpatientdetailcategory = element.inpatientdetailcategory;
          obj.inpatientdetailcategorydescription =
            element.inpatientdetailcategorydescription;
          obj.inpatientdetails = element.inpatientdetails;
          obj.memberAdmitDate = this.convertDateFormat(element.memberAdmitDate);
          obj.memberDischargeDate = this.convertDateFormat(
            element.memberDischargeDate
          );
          obj.memberId = element.memberId;
          obj.memberIdType = element.memberIdType;
          obj.index = index;
          //obj.serviceAuthorization = element.serviceAuthorization;
          if (!duplicate.includes(element.serviceAuthorization)) {
            obj.serviceAuthorization = element.serviceAuthorization;
            serviceAuthorizationList.push({
              value: element.serviceAuthorization,
              index: index,
            });
            //console.log(serviceAuthorizationList);
            duplicate.push(element.serviceAuthorization);
          }
          let date = this.dateFormat(element.memberAdmitDate);
          //const payload = {value: element.serviceAuthorization, key: "AuthID"}

          this.inPatientData.push(obj);
          if (type == 'pdfGeneration') {
            pdfObj.value.push(obj);
          }
        }
      });
      this.documentsList = [];
      let apiCalls = [];
      serviceAuthorizationList.forEach((ele) => {
        const kplv = [
          { value: memberDetails.memberHmoID, key: 'MemberID' },
          { value: 'DC_SUMMARY', key: 'documentType' },
          { value: ele.value, key: 'AuthID' },
        ];
        //  let apiObservable=this.memberClinicalCommunicationService.listDocuments(kplv);
        apiCalls.push({ payload: kplv, index: ele.index });
      });
      let data =
        this.memberClinicalCommunicationService.listDocuments(apiCalls);

      //console.log(data);
      if (data && Array.isArray(data)) {
        this.medicationLoading = true;
        this.loading = true;
        this.clinicalSummaryLoading = true;
        let allDoc: any = [];
        data[0].subscribe((docElement) => {
          for (let i = 0; i < docElement.length; i++) {
            let result = docElement[i];
            if (result.keyValuePairListWrapperlist.length > 0) {
              allDoc = this.generateList(result.keyValuePairListWrapperlist);
              this.documentsList = [...this.documentsList, ...allDoc];
              console.log("this.documentsList",this.documentsList);
              if (allDoc.lastAutoTablelength) {
                this.pdfDoc = true;
              } else {
                this.pdfDoc = false;
              }
              let docContentList = [];
              allDoc.forEach((ele) => {
                if (ele.Id) {
                  docId = ele.Id;
                }
                if (ele.DocumentClass) {
                  docCode = ele.DocumentClass;
                }
                let docContent = {
                  docId: docId,
                  docCode: docCode,
                };
                docContentList.push(docContent);
                this.inPatientData.forEach((oldObject) => {
                  if (oldObject.index == data[1][i].index) {
                    oldObject.docContent = docContentList;
                  }
                });

                if (type == 'pdfGeneration') {
                  pdfObj.value.forEach((element) => {
                    if (element.index == data[1][i].index) {
                      element.docContent = docContentList;
                    }
                  });
                }
              });
            }
          }
        });
      }

      this.medicationLoading = false;
      this.loading = false;
      this.clinicalSummaryLoading = false;

      //pdfObj.value.push(obj);
      if (type == 'pdfGeneration') {
        this.pdfInpatientData.push(pdfObj);
      }
    } else {
      if (type == 'pdfGeneration') {
        let obj = {
          id: memberDetails.memberId,
          memberId: memberId,
          memberName: memberName,
          msg: 'No clinical events exist for the selected type, member and date',
          errormsg: 'error',
        };
        this.pdfInpatientData.push(obj);
      }
      this.loading = false;
      this.medicationLoading = false;
      this.clinicalSummaryLoading = false;
      this.admitDischardeLoading = false;
      this.inPatientData = [
        'No clinical events exist for the selected type, member and date',
      ];
    }
    this.medicationLoading = false;
    this.loading = false;
    this.clinicalSummaryLoading = false;
    this.admitDischardeLoading = false;
  }
  getMemberClinicalSummary(
    id,
    hmid,
    type?: string,
    idPdf?: string,
    memberId?: string,
    memberName?: string
  ) {
    //console.log("getMemberClinicalSummary---",id,hmid,type,idPdf,memberId,memberName);
    this.clinicalSummaryPayload = {
      // StartDate: this.onemonth(),
      // EndDate: this.endDtae(),
      // PersonID: id,
      startDate: this.onemonth(),
      endDate: this.endDtae(),
      memberId: hmid,
      memberUId: id,
    };
    //console.log("clinicalSummaryPayload-----",this.clinicalSummaryPayload);
    const clinicalAndVisitResponse =
      this.memberClinicalCommunicationService.getClinicalAndReason([
        { payload: this.clinicalSummaryPayload },
      ]);
    if (clinicalAndVisitResponse && clinicalAndVisitResponse.length > 0) {
      clinicalAndVisitResponse[0][0].subscribe(
        (res) => {
          this.getMemberClinicalSummaryWork(
            res[1],
            res[0],
            type,
            idPdf,
            memberId,
            memberName
          );
        },
        (error) => {
          if (type == 'pdfGeneration') {
            let obj = {
              id: idPdf,
              memberId: memberId,
              memberName: memberName,
              msg: 'No clinical events exist for the selected type, member and date',
              errormsg: 'error',
            };
            this.pdfclinicalSummaryData.push(obj);
          }
          this.loading = false;
          this.medicationLoading = false;
          this.clinicalSummaryLoading = false;
          this.clinicalEncounterDate = [
            'No clinical events exist for the selected type, member and date',
          ];
          this.clinicalSummaryresult = [];
          this.formattedDate = [];
          this.encounterDateArray = [];
        }
      );
    }
  }
  getMemberClinicalSummaryWork(
    ClinicalSummaryResponse,
    reasonForVisitResponse,
    type,
    idPdf,
    memberId,
    memberName
  ) {
    this.formattedDate = [];
    this.formattedDateTime = [];
    this.clinicalSummaryresult = [];
    this.encounterDateArray = [];
    this.clinicalEncounterDate = [];
    const practiceIdsToAvoid = [];
    this.aips = [];
    this.vitals = [];
    var pdfObj: any = {
      id: idPdf,
      memberId: memberId,
      memberName: memberName,
      value: [],
    };
    this.memberClinicalCommunicationService
      .getPracticeIds()
      .subscribe((practiceIds: any) => {
        const response = practiceIds.responseDatasArray;
        response.map((practiceIdObj) => {
          if (practiceIdObj.practice_id) {
            practiceIdsToAvoid.push(practiceIdObj.practice_id);
          }
        });
        if (true) {
          if (true) {
            if (ClinicalSummaryResponse['body']) {
              this.ClinicalSummaryDataResponse =
                ClinicalSummaryResponse['body'];
            }

            if (
              this.ClinicalSummaryDataResponse.PatientClinInfoVisit &&
              this.ClinicalSummaryDataResponse.PatientClinInfoVisit.VISIT &&
              this.ClinicalSummaryDataResponse.PatientClinInfoVisit.VISIT
                .length > 0
            ) {
              this.ClinicalSummaryDataResponse.PatientClinInfoVisit.VISIT.map(
                (data) => {
                  if (
                    data.VisitType == 'Office Visit' &&
                    practiceIdsToAvoid.indexOf(data.PracticeID) === -1
                  ) {
                    let encounterIdFromVisit = data.EncounterID;
                    this.locationID = data.LocationID;
                    this.locationName = data.LocationName;
                    this.eventID = data.EventID;
                    this.eventName = data.Event;
                    this.providerName = data.RenderingProvDesc;
                    let vitals: any[] = [];
                    if (
                      this.ClinicalSummaryDataResponse.PatientClinInfoVitals &&
                      this.ClinicalSummaryDataResponse.PatientClinInfoVitals
                        .VITALS &&
                      this.ClinicalSummaryDataResponse.PatientClinInfoVitals
                        .VITALS.length > 0
                    ) {
                      this.ClinicalSummaryDataResponse.PatientClinInfoVitals.VITALS.map(
                        (x) => {
                          if (x.EncounterID == encounterIdFromVisit) {
                            vitals.push(x);
                          }
                        }
                      );
                    }
                    if (vitals.length == 0) {
                      if (type !== 'pdfGeneration') {
                        vitals = [
                          'No clinical events exist for the selected type, member and date',
                        ];
                      } else {
                        vitals = [
                          {
                            msg: 'No clinical events exist for the selected type, member and date',
                          },
                        ];
                      }
                    }
                    let aipRes: any[] = [];
                    let aips: any[] = [];
                    if (
                      this.ClinicalSummaryDataResponse.PatientClinInfoAip &&
                      this.ClinicalSummaryDataResponse.PatientClinInfoAip.AIP &&
                      this.ClinicalSummaryDataResponse.PatientClinInfoAip.AIP
                        .length > 0
                    ) {
                      this.ClinicalSummaryDataResponse.PatientClinInfoAip.AIP.map(
                        (x) => {
                          if (
                            x.EncounterID == encounterIdFromVisit &&
                            (x.DetailType == 'Plan Orders' ||
                              x.DetailType == 'Assessment' ||
                              x.DetailType == 'Patient Plan' ||
                              x.DetailType == 'Provider Plan')
                          ) {
                            aips.push(x);
                          }
                        }
                      );
                    }
                    if (aips.length > 0) {
                      let i;
                      for (i = 1; i < aips.length + 1; i++) {
                        let Assesment = aips.filter(
                          (ele) =>
                            ele.DetailType == 'Assessment' &&
                            ele.DetailType !== 'Impression' &&
                            ele.DetailTypePriority == i
                        );
                        // aipRes.concat(Assesment);
                        let patientPlan = aips.filter(
                          (ele) =>
                            ele.DetailType == 'Patient Plan' &&
                            ele.DetailType !== 'Impression' &&
                            ele.DetailTypePriority == i
                        );
                        // aipRes.concat(patientPlan);
                        let providerPlan = aips.filter(
                          (ele) =>
                            ele.DetailType == 'Provider Plan' &&
                            ele.DetailType !== 'Impression' &&
                            ele.DetailTypePriority == i
                        );
                        let planOrder = aips.filter(
                          (ele) =>
                            ele.DetailType == 'Plan Orders' &&
                            ele.DetailType !== 'Impression' &&
                            ele.DetailTypePriority == i
                        );
                        aipRes = aipRes.concat(
                          Assesment,
                          providerPlan,
                          patientPlan,
                          planOrder
                        );
                      }
                    } else if (aipRes.length == 0) {
                      if (type !== 'pdfGeneration') {
                        aipRes = [
                          'No clinical events exist for the selected type, member and date',
                        ];
                      } else {
                        aipRes = [
                          {
                            msg: 'No clinical events exist for the selected type, member and date',
                          },
                        ];
                      }
                    }
                    const ReasonForVisitData = reasonForVisitResponse['body'];

                    const a = ReasonForVisitData.ReasonsForVisit.RFV;
                    var mostRecentObject = [];
                    var reasons;
                    a.map((e) => {
                      if (e.encounter != undefined) {
                        if (
                          this.convertDateFormat(e.encounter.enc_timestamp) ==
                          this.convertDateFormat(data.EncounterDate)
                        ) {
                          mostRecentObject.push(e);
                        }
                      }
                    });
                    reasons = mostRecentObject[0];
                    var reasonForVisit = '';
                    if (reasons) {
                      if (reasons.chiefComplaint1) {
                        reasonForVisit = reasons.chiefComplaint1;
                      }
                      if (reasons.chiefComplaint2) {
                        reasonForVisit =
                          reasonForVisit + ', ' + reasons.chiefComplaint2;
                      }
                      if (reasons.chiefComplaint3) {
                        reasonForVisit =
                          reasonForVisit + ', ' + reasons.chiefComplaint3;
                      }
                      if (reasons.chiefComplaint4) {
                        reasonForVisit =
                          reasonForVisit + ', ' + reasons.chiefComplaint4;
                      }
                      if (reasons.chiefComplaint5) {
                        reasonForVisit =
                          reasonForVisit + ', ' + reasons.chiefComplaint5;
                      }
                    }
                    let obj = {
                      VisitType: data.VisitType,
                      EncounterDate: this.convertDateTimeFormat(
                        data.EncounterDate
                      ),
                      //EncounterDate: data.EncounterDate,
                      EncounterID: data.EncounterID,
                      vitals: vitals,
                      aips: aipRes,
                      reasonForVisit: reasonForVisit,
                      locationDetails: data.LocationName,
                      locationName: data.LocationName,
                      providerDetails: data.RenderingProvDesc,
                      providerName: data.RenderingProvDesc,
                      eventDetails: data.Event,
                      event: data.Event,
                    };
                    this.clinicalSummaryresult.push(obj);
                    if (type == 'pdfGeneration') {
                      pdfObj.value.push(obj);
                    }
                  }
                }
              );
              if (type == 'pdfGeneration') {
                this.pdfclinicalSummaryData.push(pdfObj);
              }
              this.clinicalSummaryresult.map((value) => {
                this.encounterDateArray.push(new Date(value.EncounterDate));
              });
              let sortedDate = this.encounterDateArray.sort((a, b) => b - a);
              sortedDate.map((element) => {
                this.formattedDateTime.push(this.convertDateTime(element));
                this.formattedDate.push(this.convert(element));
              });
              this.formattedDateTime = this.formattedDateTime.filter(
                this.onlyUnique
              );
              this.encounterDate = this.formattedDateTime[0];
              this.clinicalSummaryresult.forEach((element) => {
                element.EncounterDate = element.EncounterDate.slice(0, 16);
              });
              this.clinicalSummaryresult.map((x) => {
                if (x.EncounterDate == this.encounterDate) {
                  this.clinicalEncounterDate.push(x);
                }
              });
              this.selectedEncounterDateList =
                this.clinicalEncounterDate.filter(
                  (x) => x.EncounterDate == this.encounterDate
                );
              if (this.selectedEncounterDateList.length == 1) {
                this.eventName = this.selectedEncounterDateList[0].eventDetails;
              } else {
                this.eventName = this.selectedEncounterDateList
                  .map(function (elem) {
                    return elem.eventDetails;
                  })
                  .join(', ');
              }
              if (
                this.clinicalEncounterDate &&
                this.clinicalEncounterDate.length > 0
              ) {
                this.providerName =
                  this.clinicalEncounterDate[0].providerDetails;
                this.locationName =
                  this.clinicalEncounterDate[0].locationDetails;
                this.eventName = this.eventName;
                this.aips = this.clinicalEncounterDate[0].aips;
                this.vitals = this.clinicalEncounterDate[0].vitals;
                this.reasonForVisit =
                  this.clinicalEncounterDate[0].reasonForVisit;
              } else if (this.clinicalEncounterDate.length == 0) {
                this.clinicalEncounterDate = [
                  'No clinical events exist for the selected type, member and date',
                ];
              }
            }
            this.clinicalSummaryLoading = false;
            this.medicationLoading = false;
            this.loading = false;
          } else {
            if (type == 'pdfGeneration') {
              let obj = {
                id: idPdf,
                memberId: memberId,
                memberName: memberName,
                msg: 'No clinical events exist for the selected type, member and date',
                errormsg: 'error',
              };
              this.pdfclinicalSummaryData.push(obj);
            }
            this.loading = false;
            this.clinicalSummaryLoading = false;
            this.medicationLoading = false;
            this.aips = [
              'No clinical events exist for the selected type, member and date',
            ];
            this.vitals = [
              'No clinical events exist for the selected type, member and date',
            ];
            this.clinicalEncounterDate = [
              'No clinical events exist for the selected type, member and date',
            ];
          }
        } else {
          if (type == 'pdfGeneration') {
            let obj = {
              id: idPdf,
              memberId: memberId,
              memberName: memberName,
              msg: 'No clinical events exist for the selected type, member and date',
              errormsg: 'error',
            };
            this.pdfclinicalSummaryData.push(obj);
          }
          this.loading = false;
          this.medicationLoading = false;
          this.clinicalSummaryLoading = false;
          this.clinicalEncounterDate = [
            'No clinical events exist for the selected type, member and date',
          ];
          this.aips = [
            'No clinical events exist for the selected type, member and date',
          ];
          this.vitals = [
            'No clinical events exist for the selected type, member and date',
          ];
          this.clinicalSummaryresult = [];
          this.formattedDate = [];
          this.encounterDateArray = [];
        }
      });
  }
  // convert IST format to MM/DD/YYYY
  convert(str) {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join('/');
  }
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  convertDateTime(str) {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    var hours = str.toString().slice(16, 21);
    return [mnth, day, date.getFullYear()].join('/') + ' ' + hours;
  }

  getPersonIdVal(
    id,
    hmid,
    type?: string,
    memberId?: string,
    memberName?: string
  ) {
    this.loading = true;
    this.clinicalSummaryLoading = true;
    this.clinicalActive = true;
    this.admitDischargeActive = false;
    this.medicationChangeActive = false;
    setTimeout(() => {
      // this.memberClinicalCommunicationService
      //   .getPersonId(id)
      //   .subscribe((Response:any) => {
      //     if (Response.status === 200) {
      // let ResponseData: any;
      // ResponseData = JSON.parse(Response['_body']);
      //console.log("getPersonIdVal---- :",id,hmid,type,memberId,memberName);
      if (type == 'pdfGeneration') {
        this.getMemberClinicalSummary(
          //Response.body,
          id,
          hmid,
          type,
          //id,
          memberId,
          memberName
        );
      } else {
        //console.log("mem id -----:",hmid)
        this.getMemberClinicalSummary(id, hmid);
      }
    }, 200);
  }

  encounterDateChange() {
    this.loadingDashboard = true;
    setTimeout(() => {
      this.locationName = '';
      this.eventName = '';
      this.providerName = '';
      this.reasonForVisit = '';
      this.selectedEncounterDateList = this.clinicalSummaryresult.filter(
        (x) => x.EncounterDate == this.encounterDate
      );
      if (this.selectedEncounterDateList.length == 1) {
        this.eventName = this.selectedEncounterDateList[0].eventDetails;
      } else {
        this.eventName = this.selectedEncounterDateList
          .map(function (elem) {
            return elem.event;
          })
          .join(', ');
      }
      this.clinicalEncounterDate = this.selectedEncounterDateList;
      this.locationName = this.selectedEncounterDateList[0].locationDetails;
      this.eventName = this.eventName;
      this.providerName = this.selectedEncounterDateList[0].providerDetails;
      this.aips = this.selectedEncounterDateList[0].aips;
      this.vitals = this.selectedEncounterDateList[0].vitals;
      this.reasonForVisit = this.selectedEncounterDateList[0].reasonForVisit;
      this.loadingDashboard = false;
    }, 1);
  }

  inpatientCollapse() {
    if (this.inpatCollapDisplay == false) {
      this.inpatCollapDisplay = true;
      this.inpatientClose = true;
    } else {
      this.inpatCollapDisplay = false;
      this.inpatientClose = false;
    }
  }

  public convertDateFormat(str) {
    try {
      if (str) {
        var month = str.slice(5, 7);
        var date = str.slice(8, 10);
        var year = str.slice(0, 4);
        var totalDate = month + '/' + date + '/' + year;
        return totalDate;
      } else {
        return '';
      }
    } catch (err) {
      throw err;
    }
  }

  public convertDateTimeFormat(str) {
    try {
      if (str) {
        var month = str.slice(5, 7);
        var date = str.slice(8, 10);
        var year = str.slice(0, 4);
        var time = str.slice(11, 19);
        var totalDate = month + '/' + date + '/' + year;
        return totalDate + ' ' + time;
      } else {
        return '';
      }
    } catch (err) {
      throw err;
    }
  }

  dateFormat(str) {
    return str ? str.split('T')[0] : '';
  }
  todaydate() {
    let current_datetime = new Date();
    let formatted_date =
      current_datetime.getMonth() +
      1 +
      '/' +
      current_datetime.getDate() +
      '/' +
      current_datetime.getFullYear();
    return formatted_date;
  }
  //Two digit month
  getFullMonth() {
    let date = new Date();
    let month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month;
  }
  todaydateWithoutSymbols() {
    let current_datetime = new Date();
    let formatted_date =
      this.getFullMonth() +
      '' +
      current_datetime.getDate() +
      '' +
      current_datetime.getFullYear();
    let formatted_date_withoutSpace = formatted_date.trim();
    return formatted_date_withoutSpace;
  }
  oneWeekdate() {
    var targetDate = new Date();
    if (this.duration == '15') {
      targetDate.setDate(targetDate.getDate() - 15);
      var dd = targetDate.getDate();
      var mm = targetDate.getMonth() + 1;
      var yyyy = targetDate.getFullYear();
      var dateString = mm + '/' + dd + '/' + yyyy;
    } else if (this.duration == '7') {
      targetDate.setDate(targetDate.getDate() - 7);
      var dd = targetDate.getDate();
      var mm = targetDate.getMonth() + 1;
      var yyyy = targetDate.getFullYear();
      var dateString = mm + '/' + dd + '/' + yyyy;
    } else if (this.duration == '30') {
      targetDate.setDate(targetDate.getDate() - 30);
      var dd = targetDate.getDate();
      var mm = targetDate.getMonth() + 1;
      var yyyy = targetDate.getFullYear();
      var dateString = mm + '/' + dd + '/' + yyyy;
    }

    return dateString;
  }

  onemonth() {
    var targetDate = new Date();
    targetDate.setDate(targetDate.getDate() - this.selectedduration);
    var dd = ('0' + targetDate.getDate()).slice(-2);
    var mm = ('0' + (targetDate.getMonth() + 1)).slice(-2);
    var yyyy = targetDate.getFullYear();
    var dateString = yyyy + '/' + mm + '/' + dd;
    return dateString;
  }

  endDtae() {
    let current_datetime = new Date();
    let formatted_date =
      current_datetime.getFullYear() +
      '/' +
      ('0' + (current_datetime.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + current_datetime.getDate()).slice(-2);
    return formatted_date;
  }

  activeTab(event) {
    let idAttr = event.srcElement.attributes.id;
    this.activeEl = idAttr.nodeValue;
  }

  hoveringMethod(row) {
    this.hovering = true;
    this.hoveringRow = row;
  }
  hoveringVal() {
    this.hovering = false;
  }
  hoveringMethodInpatient(row) {
    this.hoveringIpatient = true;
    this.hoveringRow = row;
  }
  hoveringValInpatient() {
    this.hoveringIpatient = false;
  }
  hoveringMethodMedication(row) {
    this.hoveringMedication = true;
    this.hoveringRow = row;
  }
  hoveringValMedication() {
    this.hoveringMedication = false;
  }

  checkTableRow(event) {
    $('.showRows').css({ display: 'none', background: 'transparent' });
    $('.accordion-toggle').css({ background: 'transparent' });
    if (event.srcElement.nodeName == 'INPUT') {
      event.srcElement.parentElement.parentNode.classList.add('arrowIcon');
      // event.srcElement.parentNode.parentElement.nextElementSibling["style"].display = 'none';
      //event.srcElement.parentNode.parentElement.nextElementSibling["style"].display
    }
    /*  if(event.srcElement.nodeName == 'INPUT' && event.srcElement.checked == 'true') {
        event.srcElement.parentNode.parentElement.nextElementSibling["style"].display = 'none';
      }*/
    if (
      event.srcElement.nodeName == 'TR' &&
      event.srcElement.nextElementSibling.attributes['id'].value ==
        event.srcElement.attributes['data-target'].value.slice(1)
    ) {
      event.srcElement.parentElement.classList.add('arrowIconTR');
      event.srcElement.nextElementSibling['style'].display = 'table-row';
      event.srcElement.nextElementSibling['style'].background =
        'rgba(225,237,255,0.5)';
      event.srcElement['style'].background = 'rgba(225,237,255,0.5)';
      $('table.pagingTable tr, .previous, .next').hide();
      $('#hdnActivePage').val(1);
    }
    if (
      event.srcElement.nodeName != 'TR' &&
      event.srcElement.parentNode.parentElement.nextElementSibling.attributes[
        'id'
      ].value ==
        event.srcElement.parentNode.parentElement.attributes[
          'data-target'
        ].value.slice(1)
    ) {
      event.srcElement.parentNode.classList.add('arrowIconTR');
      event.srcElement.parentNode.parentElement.nextElementSibling[
        'style'
      ].display = 'table-row';
      event.srcElement.parentNode.parentElement.nextElementSibling[
        'style'
      ].background = 'rgba(225,237,255,0.5)';
      event.srcElement.parentNode.parentElement['style'].background =
        'rgba(225,237,255,0.5)';
    }
  }
  showTabContent() {
    alert('click');
    $('.tab-pane.active.in').css('display', 'block');
  }
  checkTableRowMobile(event) {
    $('.showRows.collapse').css({ display: 'none', background: 'transparent' });
    $('.accordion-toggle').css({ background: 'transparent' });
    if (
      event.srcElement.nodeName == 'TR' &&
      event.srcElement.nextElementSibling.attributes['id'].value ==
        event.srcElement.attributes['data-target'].value.slice(1)
    ) {
    }
    if (event.srcElement.nodeName == 'INPUT') {
      event.srcElement.parentNode.parentElement.nextElementSibling[
        'style'
      ].display = 'none';
    }
    if (
      event.srcElement.nodeName != 'INPUT' &&
      event.srcElement.parentNode.nextElementSibling.attributes['id'].value ==
        event.srcElement.parentNode.attributes['data-target'].value.slice(1)
    ) {
      event.srcElement.parentNode.nextElementSibling['style'].display =
        'table-row';
      event.srcElement.parentNode.nextElementSibling['style'].background =
        'rgba(225,237,255,0.5)';
      event.srcElement.parentNode['style'].background = 'rgba(225,237,255,0.5)';
    }
  }

  closeExpandedRow() {
    $('.collapse').css('display', 'none');
    $('.accordion-toggle').css('background', 'transparent');
  }
  generateList(list) {
    let array = [];
    list.map((row) => {
      let obj = {};
      row.keyvaluePairWr.map((item) => {
        obj[item.key] = item.value;
      });
      array.push(obj);
    });
    return array;
  }

  // getListofDocuments(id, obj?) {
  //to get list of documents;//'302M97378'/id
  // this.documentsList = [];
  // const kplv = [
  //   { value: id, key: "MemberID" },
  //   { value: "DC_SUMMARY", key: "documentType" },
  // ];
  // if(obj){
  //   kplv.push(obj);
  //   }
  // this.memberClinicalCommunicationService
  //   .listDocuments(kplv)
  //   .subscribe((response) => {
  //     this.medicationLoading = true;
  //     this.loading = true;
  //     this.clinicalSummaryLoading = true;
  //     let result = response.json();
  //     this.documentsList = this.generateList(
  //       result.keyValuePairListWrapperlist
  //     );
  //     if (this.documentsList.length && this.pdfDoc == false) {
  //       this.pdfDoc = true;
  //     } else {
  //       this.pdfDoc = false;
  //     }
  //     this.medicationLoading = false;
  //     this.loading = false;
  //     this.clinicalSummaryLoading = false;
  //     //this.documentsList = [];
  //   });
  //}
  getDocument(doc) {
    // this.loading = true;
    const docId = doc.Id; //this.getvalue(doc, 'Id');
    const docClass = doc.DocumentClass; //this.getvalue(doc, 'DocumentClass');
    this.memberClinicalCommunicationService
      .getDocument(docId, docClass, null)
      .subscribe((res) => {
        const responseData = res;
        const state = _.find(responseData.keyValuePairList, ['key', 'State']);
        // if (state && (state.value === this.userState || this.clientAccessStates.includes(state.value)) || this.documentCode === 'GEN_REF_DOC') {

        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          const blob = this.binary64ToBlob(
            responseData.docContent,
            responseData.fileType,
            512
          );
          saveAs(blob, responseData.filename);
          // this.loading = false;
        } else {
          const blob = this.b64toBlob(
            responseData.docContent,
            responseData.fileType,
            512
          );
          const urlBlob = URL.createObjectURL(blob);
          window.open(urlBlob, '_blank', 'location=yes,height=570,width=520');
          // this.loading = false;
        }
        // } else {
        // this.loading = false;
        // }
      });
  }
  binary64ToBlob(binary64String, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(binary64String);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  //   datePipeFilter(){
  //    let datePipe= new DateFormatPipe();
  //    this.DateFilteredData = datePipe.transform(this.memberMedicationData,'','');
  //   }
  selectedDurationPeriod() {
    this.unselectFlag = false;
    this.getMemberdetails(
      this.username,
      this.selectedduration,
      '',
      this.searchInput
    );

    if (this.selectedduration > 30) {
      this.disableFlag = true;
    } else {
      this.disableFlag = false;
    }
  }

  filterMember(event: any) {
    let reg = new RegExp(this.searchInput, 'gi');
    this.loadingDashboard = true;
    let tempFilter = [];
    let tempFilter2 = [];
    this.memberdetailsPdfData.map((data) => {
      if (
        this.searchInput &&
        (reg.test(data.memberHmoID) ||
          reg.test(data.memberFirstName + data.memberLastName) ||
          reg.test(data.pcpName))
      ) {
        tempFilter2.push(data);
      } else {
        tempFilter.push(data);
      }
    });

    if (this.searchInput && tempFilter2.length) {
      if (tempFilter2.length > 50) {
        this.virtualMemberDetailData = tempFilter2.slice(0, 49);
        $('#display').show();
      } else {
        this.virtualMemberDetailData = tempFilter2;
        $('#display').hide();
      }
    } else if (!this.searchInput && tempFilter.length) {
      if (tempFilter.length > 50) {
        this.virtualMemberDetailData = tempFilter.slice(0, 49);
        $('#display').show();
      } else {
        this.virtualMemberDetailData = tempFilter;
        $('#display').hide();
      }
    } else {
      this.virtualMemberDetailData = [
        'No records found for the searched criteria',
      ];
      $('#display').hide();
    }
    //console.log(this.virtualMemberDetailData.length);

    this.loadingDashboard = false;
    var filterItems = $('.clinicalDesktopTable .accordion-toggle.rows').length;
    let filterItemsMobile = $(
      '.clinicalMobileTable .accordion-toggle.rows'
    ).length;
    if (filterItems || filterItemsMobile <= 49) {
      $(
        '.clinicalDesktopTable .viewMoreDisplay',
        '.clinicalMobileTable .viewMoreDisplay'
      ).hide();
    } else {
      $(
        '.clinicalDesktopTable .viewMoreDisplay.searchInputViewMore',
        '.clinicalMobileTable .viewMoreDisplay.searchInputViewMore'
      ).show();
    }
  }

  openModal(modalId:any){
    const modal=new Modal(document.getElementById(modalId));
    modal.show();
  }
  closeModal(modalId:any){
    const modalElement=document.getElementById(modalId);
    const modal=Modal.getInstance(modalElement);
    if(modal!=null){
      modal.hide();
    }

  }
  enableFalgClicked(e:any){
this.currentTrIndex=e;
  }
}